{
  "404": {
    "title": "La página que busca no se ha encontrado... 👀",
    "subtitle": "Por favor verifica si el enlace al que estás intentando acceder es correcto."
  },
  "LANDING": {
    "nav": {
      "calendar": "Agenda",
      "bookingPage": "Página de reservas",
      "pricing": "Planes"
    },
    "landing": {
      "metaTitle": "Agenda de reservas online",
      "pageTitle": "¿Tu teléfono no para de sonar?? 😤",
      "pageDescription": "Recibe reservas 24/7 a través de tu página de reservas personalizada y reduce las inasistencias con recordatorios automáticos por SMS.",
      "tagline": "Agenda de reservas online nº 1 en España 🇪🇸",
      "taglineBarbers": "Agenda de reservas online nº1 en España para Barberos",
      "taglineSalon": "Agenda de reservas online nº1 en España para Peluqueros",
      "taglineNails": "Agenda de reservas online simple y flexible para Artistas de Uñas",
      "taglineMakeup": "Agenda de reservas online nº1 en España para Maquilladores",
      "taglineSpa": "Agenda de reservas online nº1 en España para Spas",
      "taglineGym": "Agenda de reservas online simple y flexible para tu Estudio o Gimnasio",
      "taglinePts": "Agenda de reservas online simple y flexible para Entrenadores Personales",
      "taglinePhysio": "Agenda de reservas online nº1 en España para Fisioterapeutas",
      "taglinePsy": "Agenda de reservas online nº1 en España para Psicólogos",
      "taglineNutri": "Agenda de reservas online nº1 en España para Nutricionistas",
      "taglineDentist": "Agenda de reservas online nº1 en España para Clínicas Dentales",
      "taglinePharma": "Agenda de reservas online nº1 en España para Farmacias",
      "taglineTherapy": "Agenda de reservas online nº1 en España para Centros de Terapias",
      "taglineOsteo": "Agenda de reservas online nº1 en España para Osteópatas",
      "taglineHomeo": "Agenda de reservas online nº1 en España para Homeópatas",
      "taglineReiki": "Agenda de reservas online nº1 en España para Maestros de Reiki",
      "taglineAcu": "Agenda de reservas online nº1 en España para Acupuntura",
      "featuresPanel8": {
        "text": "Ver más"
      },
      "stats": {
        "title1": "+20 millones",
        "text1": "reservas procesadas",
        "title2": "+3 millones",
        "text2": "clientes reservaron",
        "title3": "+1.500",
        "text3": "negocios en España",
        "title4": "+12.000",
        "text4": "profesionales usan"
      },
      "how-to": {
        "pill1": "CONTROL TOTAL",
        "title1": "Tu agenda siempre contigo",
        "text1": "Accede a tu agenda en cualquier momento en tu teléfono móvil. ¡Gestionar tu negocio nunca fue tan simple!",
        "pill2": "OPCIONAL",
        "title2": "El fin de las llamadas perdidas",
        "text2": "Personaliza tu página de reservas y compártela con tus clientes, ¡les encantará!"
      },
      "noCreditCardNeeded": "No necesitas tarjeta de crédito.",
      "terms": "Términos y condiciones",
      "privacy": "Política de privacidad",
      "cookies": "Política de cookies",
      "cookiesCta": "Ver política de cookies",
      "help": "¿Tiene preguntas?",
      "faqs": "Preguntas Frecuentes",
      "login": "Entrar",
      "promoCopy": "¡Utiliza el Plan Pro 3 meses por el precio de 1!",
      "heroPromoBadge": "3 meses Pro por el precio de 1",
      "cancelAnytime": "Cancela cuando quieras",
      "noCreditCard": "No es necesario insertar tarjeta de crédito",
      "googleRating": {
        "score": "4.9",
        "reviews": "+450 reseñas"
      },
      "registerCta": "Registrar negocio",
      "registerCta2": "Registrar",
      "signupCtaAd": "Registrate",
      "contactCta": "Habla con nosotros",
      "headerDescription": "Con tu propia página de reservas personalizada, tus clientes pueden comprobar fácilmente tu disponibilidad y agendar citas de inmediato. BUK está rápidamente accesible desde tus redes sociales (Facebook, Instagram...) y puede incrementar significativamente la fidelidad hacia tu marca.",
      "featuresTitle": "¡Gestiona y Amplía Tu Negocio!",
      "featuresTitleBarber": "¡Gestiona y Amplía Tu Barbería!",
      "featuresTitleSalon": "¡Gestiona y Amplía Tu Salón de Belleza!",
      "featuresTitleNails": "¡Gestiona y Amplía Tu Negocio de Manicura!",
      "featuresTitleMakeup": "¡Gestiona y Amplía Tu Servicio de Maquillaje!",
      "featuresTitleSpa": "¡Gestiona y Amplía Tu Spa!",
      "featuresTitleGym": "¡Gestiona y Amplía Tu Gimnasio!",
      "featuresTitlePts": "¡Gestiona y Amplía Tus Sesiones de Entrenamiento Personal!",
      "featuresTitlePhysio": "¡Gestiona y Amplía Tu Centro de Fisioterapia!",
      "featuresTitlePsy": "¡Gestiona y Amplía Tu Consultorio Psicológico!",
      "featuresTitleNutri": "¡Gestiona y Amplía Tu Consultorio de Nutrición!",
      "featuresTitleDentist": "¡Gestiona y Amplía Tu Clínica Dental!",
      "featuresTitlePharma": "¡Gestiona y Amplía Tu Farmacia!",
      "featuresTitleTherapy": "¡Gestiona y Amplía Tu Centro de Terapia!",
      "featuresTitleOsteo": "¡Gestiona y Amplía Tu Clínica Osteopática!",
      "featuresTitleHomeo": "¡Gestiona y Amplía Tu Clínica Homeopática!",
      "featuresTitleReiki": "¡Gestiona y Amplía Tus Sesiones de Reiki!",
      "featuresTitleAcu": "¡Gestiona y Amplía Tus Sesiones de Acupuntura y Medicina Tradicional China!",
      "footerLinksPrefix": "reservas Online para",
      "features": {
        "calendarTitle": "Agenda Online",
        "calendarText": "Accede a tu agenda de reservas en cualquier momento y lugar desde tu smartphone y recibe notificaciones de nuevas reservas en tiempo real.",
        "bookingTitle": "Página de reservas",
        "bookingText": "Tu logotipo, tus colores, tu imagen. Personaliza la página de reservas a la imagen de tu negocio.",
        "teamTitle": "Gestión de Equipo",
        "teamText": "Gestiona mejor los horarios de tu equipo y distribuye las reservas según las preferencias de tus clientes.",
        "smsTitle": "Recordatorios por SMS",
        "smsText": "Ahorra tiempo con el envío automático de recordatorios por SMS y correo electrónico en la víspera de las reservas.",
        "statsTitle": "Estadísticas",
        "statsText": "Optimiza tu negocio accediendo a estadísticas y fichas de cliente. Conoce a tus clientes y sus preferencias.",
        "bookingsTitle": "Reservas 24/7",
        "bookingsText": "Recibe reservas en tu agenda online en cualquier momento y lugar con actualizaciones y notificaciones en tiempo real.",
        "marketing2Title": "Marketing Integrado",
        "marketing2Text": "Envía promociones a tus clientes con campañas de SMS y correo electrónico que los hacen volver.",
        "mbway2Title": "Pagos Online",
        "mbway2Text": "Permite que tus clientes paguen por adelantado al reservar citas, evitando cancelaciones de último momento sin costo adicional. Acepta tarjetas de crédito, Apple Pay y Google Pay.",
        "google2Title": "Posiciónate en Google Reviews",
        "google2Text": "Destaca tu negocio en Google. Después de cada reserva, tus clientes reciben un email para valorar tu negocio en Google.",
        "loyaltyTitle": "Programa de Fidelización",
        "loyaltyText": "Crea un programa de fidelización con premios para incentivar el regreso de tus mejores clientes.",
        "crmTitle": "CRM Personalizado",
        "crmText": "Añade campos personalizados a la página de reservas para recoger información importante y mejorar el servicio.",
        "pixelTitle": "Conversiones de Google & Meta",
        "pixelText": "Analiza el impacto de tus campañas con los píxeles integrados de Google y Meta."
      },
      "testimoniesTitle": "Lo que nuestros clientes dicen ❤️",
      "testemonies": {
        "testemonyBento": "Usar BUK permite a los clientes agendar con toda comodidad los servicios que desean. Esto facilita mucho nuestro trabajo.",
        "testemonyAnton": "BUK es fácil de usar, super interactivo, práctico y funcional, permite trabajar de manera más organizada y profesional.",
        "testemonyLigia": "Adherir a BUK fue una de las mejores decisiones que tomé a nivel profesional, ahorro horas de trabajo por semana y a mis clientes les encanta ser autónomos en sus reservas.",
        "testemonyPraga": "BUK es la plataforma que más me ha ayudado en el trabajo hasta ahora. Simple, intuitiva y bastante personalizable para cada negocio. ¡Lo recomiendo mucho! Para los clientes, muy fácil de usar."
      },
      "businessesTitle": "Elige tu negocio <br/>y regístrate gratis!",
      "everyBusiness": "Una agenda para todos los negocios.",
      "blog": "Nuestro blog",
      "reachOut": "Habla con nosotros en",
      "businesses": {
        "barber": "Barberías",
        "barbers": "Barberos",
        "salon": "Peluquerías",
        "salons": "Peluqueros/as",
        "nails": "Artistas de uñas",
        "nailss": "Artistas de uñas",
        "makeup": "Artistas de maquillaje",
        "makeups": "Artistas de maquillaje",
        "fitness": "Fitness",
        "fisio": "Fisioterapeutas",
        "osteo": "Osteópatas",
        "dentist": "Dentistas",
        "dentists": "Clínicas Dentales",
        "psy": "Psicólogos",
        "psys": "Psicólogos",
        "beauty": "Belleza",
        "sports": "Deporte",
        "gyms": "Estudios y Gimnasios",
        "pts": "Entrenadores personales",
        "health": "Salud",
        "pharma": "Farmacias",
        "pharmacies": "Farmacias",
        "therapy": "Centros de terapia",
        "alternativeTherapies": "Terapias alternativas",
        "osteopathy": "Osteopatía",
        "homeopathy": "Homeopatía",
        "reiki": "Reiki",
        "acupuncture": "Acupuntura",
        "nutri": "Nutricionistas",
        "nutricionists": "Nutricionistas",
        "others": "Otros"
      },
      "ctaSection": {
        "title": "Únete a más de 1500 negocios en España",
        "text": "Recibe reservas 24/7 a través de tu página de reservas personalizada. Envía recordatorios SMS automáticos a tus clientes y reduce las ausencias."
      },
      "footerText1": "BUK © una marca de",
      "footerText2": "desarrollado en la UE 🇪🇺",
      "refText1": "te ha invitado al BUK",
      "refText2": "Tienes un 10% de descuento en planes profesionales.",
      "refText3": "Con esta invitación de"
    },
    "landCalendar": {
      "hero": {
        "title": "Tu agenda siempre contigo",
        "desc": "Accede a tu agenda en cualquier momento y lugar. ¡Gestionar tu negocio nunca ha sido tan sencillo!"
      },
      "feat1": {
        "title": "Configura tu agenda según la realidad de tu negocio",
        "check1": "Configura tu horario de atención y bloquea días libres y horas de comida",
        "check2": "Opción de vista diaria o semanal",
        "check3": "Configura con cuánta antelación deseas permitir reservas (hechas por tus clientes)",
        "check4": "Oculta la vista de colaboradores en sus días libres"
      },
      "feat2": {
        "title": "Recordatorios SMS/email ilimitados y personalizables",
        "check1": "Personaliza las comunicaciones con tus clientes",
        "check2": "Escribe tu propio SMS y elige el nombre del remitente",
        "check3": "Añade información importante en los emails de reserva"
      },
      "feat3": {
        "title": "Estadísticas de tu negocio",
        "desc": "Consulta datos importantes para hacer crecer tu negocio:",
        "check1": "Número de reservas",
        "check2": "Servicios más solicitados por los clientes",
        "check3": "Datos de facturación por tienda y colaborador",
        "check4": "Número de visitas a la página de reservas"
      },
      "feat4": {
        "title": "Accede al perfil de tus clientes con un clic",
        "desc": "Obtén información relevante sobre tus clientes para una experiencia única:",
        "check1": "Datos de contacto, fecha de cumpleaños y notas",
        "check2": "Estadísticas de cliente (nº de reservas, ausencias, cancelaciones, gasto total)",
        "check3": "Historial de reservas y última visita",
        "check4": "Servicios preferidos"
      },
      "feat5": {
        "title": "¡Gestionar tu equipo nunca fue tan fácil!",
        "check1": "Sigue la agenda y productividad de todos los colaboradores",
        "check2": "Horarios y servicios diferentes por colaborador",
        "check3": "Personaliza tu calendario con colores para cada servicio"
      },
      "feat6": {
        "title": "Un acceso exclusivo para tus colaboradores",
        "desc": "Limita el acceso a la agenda con diferentes permisos:",
        "check1": "Administrador",
        "check2": "Gerente",
        "check3": "Colaborador"
      },
      "feat7": {
        "title": "SMS de Cumpleaños",
        "desc": "Mantén el contacto con tus clientes y envía un mensaje de felicitación en sus cumpleaños."
      },
      "feat8": {
        "title": "Marketing por SMS/email",
        "check1": "Crea campañas y promociones para traer de vuelta a tus clientes",
        "check2": "Filtra a los clientes para un mensaje personalizado",
        "check3": "Utiliza nuestras plantillas automáticas y envía una promoción en solo unos segundos"
      },
      "featIntegratedInvoicing": {
        "title": "Facturación integrada",
        "desc": "Emite facturas legalmente válidas en Portugal sin salir de BUK.",
        "check1": "Emite facturas a partir de una reserva o registro de venta",
        "check2": "Envía por email o descarga el PDF en segundos",
        "check3": "Integración con software certificado por la AT"
      },
      "featSalesCommissions": {
        "title": "Gestión de ventas y comisiones",
        "desc": "Registra ventas de servicios y productos y controla los pagos en un solo lugar.",
        "check1": "Registra ventas de reservas y productos",
        "check2": "Controla la facturación real de tu negocio",
        "check3": "Define comisiones por colaborador"
      },
      "featRoomsEquip": {
        "title": "Gestión de salas y equipos",
        "desc": "Organiza la disponibilidad de salas y equipos en tu agenda.",
        "check1": "Vista por sala con horarios ocupados y libres",
        "check2": "Evita solapamientos de reservas en el mismo espacio",
        "check3": "Asocia salas a servicios y colaboradores"
      }
    },
    "landBookingPage": {
      "hero": {
        "title": "El fin de las llamadas perdidas",
        "desc": "Personaliza tu página de reservas y comparte el enlace con tus clientes. ¡Nunca ha sido tan simple hacer una reserva!"
      },
      "feat1": {
        "title": "Una página de reservas a tu medida",
        "desc": "Personaliza tu página de reservas con tu logo y marca.",
        "check1": "Recibe reservas 24/7",
        "check2": "Comparte tu enlace de reservas con todos tus clientes"
      },
      "feat2": {
        "title": "Personaliza el proceso de reserva",
        "check1": "Enlaces de reserva personalizables para cada tienda / colaborador",
        "check2": "Configura cuánto tiempo antes permites reservas por parte de los clientes, por ejemplo: 8h, 16h, 24h",
        "check3": "Permite que los clientes reserven varios servicios en la misma reserva",
        "check4": "Solicita el pre-pago en el momento de la reserva y evita inasistencias"
      },
      "feat3": {
        "title": "Pagos online",
        "desc": "Elige entre varios métodos de pago disponibles: tarjeta de crédito, Apple Pay y Google Pay.",
        "check1": "Evita inasistencias con pre-pago online",
        "check2": "Configura el prepago online con una señal o el pago completo"
      },
      "feat4": {
        "title": "Impulsa tus reseñas en Google",
        "check1": "Aumenta la visibilidad de tu negocio en Google Maps",
        "check2": "Envía un mensaje automático a tus clientes con un enlace directo a las reseñas de Google"
      },
      "feat5": {
        "title": "La forma más simple de estar cerca de tus clientes",
        "desc": "Añade tu enlace de reservas en todas las plataformas: Facebook, Instagram, Google Maps, WhatsApp",
        "check1": "Reduce las llamadas telefónicas mientras trabajas",
        "check2": "Dedica más tiempo a lo que realmente importa: tus clientes",
        "check3": "Analiza las conversiones a través de tu Pixel de Google/Meta"
      },
      "feat6": {
        "title": "Programa de Fidelización",
        "desc": "Ofrece premios a los clientes fieles e incentiva su próxima visita.",
        "check1": "Define el premio y el número de visitas necesarias para conseguirlo",
        "check2": "Personaliza los términos y condiciones de tu programa",
        "check3": "Fortalece la relación con tus mejores clientes"
      },
      "feat7": {
        "title": "Campos Personalizados para tu Negocio",
        "desc": "Personaliza la página de reservas y el perfil del cliente con campos específicos para tu negocio.",
        "check1": "Añade campos de Texto, Fecha o Lista desplegable",
        "check2": "Elige si los campos son obligatorios u opcionales para reservas online"
      },
      "feat8": {
        "title": "Código QR Personalizado",
        "desc": "Simplifica el acceso a tu agenda con un código QR práctico.",
        "check1": "Permite reservas rápidas con un simple escaneo en tarjetas o folletos",
        "check2": "Coloca el código QR en la entrada para dar un toque moderno y accesible a tu negocio"
      }
    },
    "pricing": {
      "h1": "Planes & Precios",
      "subtext": "Puedes cancelar o cambiar tu plan en cualquier momento.",
      "perMonth": "/ mes",
      "byProvider": "por colaborador extra",
      "freeDescription": "Disfruta gratis de una agenda digital para gestionar tu negocio.",
      "proPlanDescription": "¡Más funcionalidades, envía recordatorios por correo electrónico y SMS ilimitados!",
      "proPlanDescriptionNoSMS": "Más funcionalidades, envía recordatorios por correo electrónico ilimitados!",
      "proPlusDescription": "Potencia tu negocio al máximo con más funcionalidades y personalizaciones.",
      "payAnnual": "Paga anualmente",
      "unlimitedSMS": "SMS Ilimitados",
      "features": {
        "bookingPage": "Página de reservas",
        "advancedBookingPage": "Página de reservas personalizada",
        "calendar": "Agenda Online",
        "advancedCalendar": "Configuraciones avanzadas de la agenda",
        "advancedSettings": "Más configuraciones y personalización",
        "email": "Recordatorios por correo electrónico Ilimitados",
        "email100": "Recordatorios por correo electrónico (100 gratis / mes)",
        "stats": "Estadísticas de tu negocio",
        "googleCalendar": "Sincronización con Google Calendar",
        "sms": "Recordatorios por SMS",
        "smsEmailUnlimited": "Recordatorios por correo electrónico/SMS Ilimitados",
        "unlimited": "Recordatorios por SMS Ilimitados",
        "whatsapp": "Soporte prioritario por WhatsApp",
        "one_provider": "Solo 1 colaborador",
        "contact": "Habla con nosotros",
        "all_pro": "Todo lo incluido en Pro",
        "birthday": "SMS de Cumpleaños",
        "marketingTools": "Herramientas de marketing",
        "personalizedReminders": "Recordatorios personalizados",
        "marketingCredit": "5 € / mes de descuento en marketing",
        "marketingCredit2": "50% de descuento en marketing",
        "apiAccess": "Acceso API",
        "loyalty": "Programa de Fidelización",
        "websiteIntegration": "Integración con sitio web (embedido)",
        "integratedInvoicing": "Facturación integrada",
        "googleReserve": "Google Reserve",
        "googleReviews": "Reseñas de Google",
        "viewMore": "Ver lista completa",
        "viewLess": "Ver menos"
      },
      "enterprise": "Empresa",
      "enterpriseLabel": "+20 colaboradores",
      "enterpriseDesc": "Un precio a medida, diversas opciones de personalización e integración. Trabaja con nosotros y crea la solución de gestión de reservas ideal para tu negocio.",
      "registerBusiness": "Regístrate gratis",
      "yearly": "Anual",
      "monthly": "Mensual",
      "payed_yearly": "Importe mensual / Pagado anualmente",
      "vat_included": "IVA incluido",
      "vat_not_included": "IVA no incluido",
      "morePopular": "Más popular",
      "everythingFromFree": "Todo lo incluido en el plan Gratis",
      "tryPro": "1 mes gratis con el código: TRYPRO",
      "vatDisclaimer": "¿Tienes colaboradores a tiempo parcial? Contacta con nosotros y te haremos un descuento en tu mensualidad. Los precios mostrados están sujetos al tipo de IVA vigente.",
      "withoutCommitment": "Sin compromiso"
    },
    "recover-pass-page": {
      "h3": "Recuperar contraseña",
      "newPassword": "Nueva contraseña",
      "confirmPassword": "Confirmar contraseña",
      "passwordsInvalid": "Las contraseñas no coinciden",
      "login": "Iniciar sesión",
      "submit": "Enviar",
      "emailSent": "Hemos enviado un correo electrónico con instrucciones para recuperar tu contraseña",
      "passwordSuccess": "La contraseña se ha cambiado con éxito"
    },
    "set-password-page": {
      "h3": "Crear cuenta",
      "newPassword": "Nueva contraseña",
      "confirmPassword": "Confirmar contraseña",
      "passwordsInvalid": "Las contraseñas no coinciden",
      "login": "Iniciar sesión",
      "submit": "Entrar",
      "passwordSuccess": "Tu cuenta ha sido creada con éxito"
    },
    "privacy": {
      "title": "Política de privacidad"
    },
    "unsubscribe": {
      "title": "¿Deseas dejar de recibir campañas por correo electrónico?",
      "cta": "Confirmar",
      "successMessage": "Confirmado"
    },
    "terms": {
      "title": "Términos y Condiciones de Uso"
    },
    "faqs": {
      "title": "Preguntas Frecuentes",
      "q1": "¿Qué es BUK?",
      "a1": "BUK permite que tus clientes reserven citas contigo, en cualquier lugar y en cualquier momento, de manera autónoma, sin necesidad de llamar, enviar correos electrónicos o mensajes SMS.",
      "q2": "¿Cómo instalo BUK?",
      "a2": "No hay nada que instalar. BUK utiliza las últimas tecnologías web para que tus clientes puedan hacer reservas con cualquier dispositivo (incluidos los teléfonos móviles).",
      "q3": "¿Cuánto tiempo se tarda en empezar?",
      "a3": "Unos 5 minutos, es muy rápido.",
      "q4": "¿Qué información necesito para empezar?",
      "a4": "Necesitarás la ubicación de tu negocio (si trabajas desde una ubicación fija), horarios de apertura y cierre, nombres y horarios de tu equipo y los servicios que ofreces.",
      "q5": "¿BUK es solo para barberías?",
      "q5b": "¿BUK es solo para",
      "a5": "¡Para nada! BUK está diseñado para cualquier negocio que necesite agendar citas. Es utilizado todos los días por salones de belleza, spas, entrenadores personales, fisioterapeutas y muchos otros profesionales.",
      "q6": "¿Necesito tener un sitio web para aprovechar BUK?",
      "a6": "¡No! Al crear una cuenta, recibes tu enlace público de BUK para compartir con tus clientes. Puedes usarlo en tus perfiles de redes sociales para dirigir clientes a tu página de reservas.",
      "q7": "¿Pueden ayudarme a configurar BUK?",
      "a7": "Por supuesto. Si necesitas ayuda para configurar BUK o si tienes alguna otra pregunta, contáctanos <a href=\"mailto:apoyo@buk.es\">aquí</a>.",
      "q8": "¿BUK tiene una app para dispositivos móviles?",
      "a8": "BUK utiliza las tecnologías web más recientes para que tus clientes puedan usarlo en cualquier dispositivo. No hay nada que instalar. Sin embargo, tus clientes pueden fácilmente añadir tu página de reservas a la pantalla de inicio de sus dispositivos móviles y funcionará como una app.",
      "q9": "¿Puedo recibir pagos con BUK?",
      "a9": "Sí, pero es opcional. BUK ofrece la posibilidad de que los clientes realicen el pago en el momento de la reserva por MBWAY de manera opcional y sin costos adicionales para el cliente, evitando cancelaciones o inasistencias de última hora.",
      "q10": "¿Puedo usar BUK para gestionar un equipo grande?",
      "a10": "Por supuesto, puedes agregar a tantos colaboradores como sea necesario. Todos recibirán su propio calendario y podrán configurar su propio horario.",
      "q11": "Tenemos varias ubicaciones; ¿podemos usar BUK?",
      "a11": "Por supuesto. Simplemente, añade otra ubicación a tu agenda (menú superior derecho). Puedes gestionar tantas ubicaciones como desees, todas con su propio equipo y configuraciones de reserva.",
      "q12": "¿Cuánto cuesta BUK?",
      "a12": "BUK es gratuito para un único colaborador. BUK Pro tiene un coste de 19,99 € al mes (o 13,99 € sin SMS) y cada colaborador adicional cuesta 5 € al mes (o 3,50 € sin SMS). Con pago anual, los valores mensuales bajan a 15,99 € (o 10,99 € sin SMS). Incluye funciones avanzadas como recordatorios ilimitados por SMS y por correo electrónico, y el plan Pro+ añade Google Reviews, Google Reserve y programa de fidelización. A los precios se suma el IVA. Los pagos por MBWAY tienen una pequeña comisión que nos ayuda a cubrir los costes de las transferencias. Creemos que este es el modelo de precios más justo, que te permite tener costes más bajos a medida que tu negocio crece.",
      "q13": "¿Cuánto cuesta añadir una segunda ubicación?",
      "a13": "Para poder añadir más de una ubicación necesitas suscribirte al plan PRO.",
      "q14": "¿Existe el riesgo de que varios clientes reserven el mismo servicio al mismo tiempo?",
      "a14": "No. Tan pronto como un cliente completa su proceso de reserva, BUK bloquea ese horario. Sin embargo, puedes hacer los cambios que desees en tu calendario.",
      "q15": "¿Tengo que confirmar las reservas hechas por mis clientes?",
      "a15": "No. Las reservas hechas por los clientes se confirman automáticamente y son gestionadas por BUK. Sin embargo, requerimos que los clientes proporcionen su número de teléfono y correo electrónico para poder contactarlos fácilmente si es necesario.",
      "q16": "¿BUK funcionará con mi sitio web o perfil de Facebook?",
      "a16": "Por supuesto, para recibir reservas desde tu sitio web, simplemente instala nuestro complemento para WordPress. Para Facebook y otras redes sociales, sigue las instrucciones disponibles en nuestra guía <b><a href=\"https://blog.buk.es/tu-enlace-buk-para-tu-pagina-de-reservas/\" target=\"_blank\">aquí</a>.</b>",
      "q17": "¿Qué sucede si necesito cerrar mi negocio por un tiempo o estar de vacaciones? ¿Cómo puedo configurarlo en mi calendario?",
      "a17": "Puedes simplemente hacer clic en un espacio libre en tu calendario, seleccionar <b>Bloquear Reservas</b> y ese espacio no estará disponible cuando tus clientes intenten hacer una reserva.",
      "q18": "¿Puedo programar una reserva recurrente para mis clientes?",
      "a18": "¡Sí! Al crear una reserva en tu calendario, simplemente haz clic en <b>Repetir Reserva</b>. BUK te pedirá que selecciones la frecuencia de la recurrencia y la fecha de finalización.",
      "q19": "¿BUK envía recordatorios a mis clientes?",
      "a19": "¡Sí! Los recordatorios de reserva se envían por SMS y correo electrónico 24 horas antes de la hora programada.",
      "q20": "¿Puedo reprogramar una cita si tengo una emergencia y no puedo realizar el servicio?",
      "a20": "Exigimos que los clientes proporcionen su número de teléfono y correo electrónico para que puedas contactarlos fácilmente y reprogramar las reservas. Luego, simplemente edita la reserva en tu calendario y serán notificados de la nueva fecha.",
      "q21": "¿Tengo que definir el precio de mis servicios?",
      "a21": "No, no necesitas definir el precio de tus servicios. Simplemente, deja el campo del precio en blanco al configurar tus servicios y el precio no será visible en la página de reserva.",
      "q22": "¿Puedo establecer horarios de trabajo diferentes para mi equipo?",
      "a22": "Por supuesto. Cada empleado puede tener su propio horario de trabajo. Al configurar tu equipo, simplemente haz clic en el icono del reloj junto al nombre del empleado y edita su horario. Puedes cambiar los horarios siempre que lo desees.",
      "q23": "¿Puedo agregar un botón de \"Reservar ahora\" a mi página de Facebook?",
      "a23": "Claro, simplemente ve a tu página de Facebook y edita el botón CTA (Llamada a la Acción) ubicado en el lado derecho, debajo de la imagen de portada. Elige la opción <b>Reservar ahora</b>, haz clic en <b>Continuar</b> y selecciona la opción <b>Enlace a la página</b>. Completa con tu enlace BUK, guarda los cambios y ¡listo!",
      "q24": "¿BUK incluye un sistema de facturación?",
      "a24": "Sí. Para negocios en Portugal, BUK ofrece un módulo de facturación que permite emitir facturas, recibos y notas de crédito directamente desde las reservas y ventas, con comunicación a la Autoridad Tributaria portuguesa. Está disponible en el plan Pro+ y requiere una activación y configuración sencillas."
    }
  },
  "CLIENT": {
    "clientCancelBooking": {
      "wishToDelete": "¿Quieres cancelar esta reserva?",
      "cannotCancelOnline": "Ya no es posible cancelar esta reserva online",
      "contactMerchantToCancel": "Para cancelar, por favor contacte con el establecimiento.",
      "contactMerchantPhone": "Teléfono:",
      "cancelledWithSuccess": "Reserva cancelada con éxito.",
      "ctaCancelBooking": "cancelar reserva",
      "ctaNewBooking": "nueva reserva",
      "paidRefundNote": "El reembolso del pago realizado no es automático. Deberá contactar con el responsable del establecimiento."
    },
    "clientConfirm": {
      "title": "Confirmar reserva",
      "namePlaceholder": "Nombre y apellido",
      "invalidPhoneNumber": "Por favor indica tu teléfono móvil",
      "invalidPtNumber": "El pago por MBway solo está disponible para números portugueses (+351)",
      "emailPlaceholder": "Tu correo electrónico",
      "invalidEmail": "Por favor indica tu correo electrónico",
      "vatNumberPlaceholder": "NIF",
      "invalidVatNumber": "Por favor indica tu NIF",
      "genderPlaceholder": "Género",
      "dobPlaceholder": "Fecha de Nacimiento",
      "invalidDob": "Fecha de Nacimiento inválida",
      "notesPlaceholder": "Observaciones",
      "paymentMoney": "Pagar después",
      "mbwayNotification1": "Al continuar recibirá una notificación para realizar el",
      "mbwayNotification2": "pago de",
      "mbNotification": "Generar una referencia de Multibanco (válido por {{time}})",
      "requiredField": "Campo obligatorio.",
      "ctaConfirmBooking": "Confirmar",
      "ctaPayBooking": "Pagar",
      "termsConditions1": "He leído y acepto los",
      "termsConditions1General": "He leído y acepto los",
      "termsConditions1b": "He leído y acepto los",
      "termsConditions2": "Términos y condiciones",
      "termsConditions3": "y",
      "termsConditions3b": ".",
      "termsConditions4": "Política de Privacidad",
      "termsConditions4b": ".",
      "termsConditions5": "de",
      "marketingCheckbox": "Acepto recibir información comercial y promociones adaptadas a mi perfil e intereses.",
      "marketingCorporateCheckbox": "Acepto recibir comunicaciones comerciales relativas a productos y servicios de óptica o audiología adaptadas a mi perfil, así como sobre promociones, eventos o nuevos productos y servicios.",
      "termsConditionsCorporate1": "He leído y acepto la Política de Privacidad",
      "termsConditionsCorporate2": "y los Términos y Condiciones",
      "paymentMethod": "Elige el método de pago",
      "creditCard": "Tarjeta de Crédito",
      "depositBooking": "Pagar ahora",
      "bookingDataTitle": "Datos de la reserva",
      "phoneOtpTitle": "Código de seguridad",
      "phoneOtpSent": "Introduzca el código de 6 dígitos que enviamos por SMS a {{phone}}.",
      "phoneOtpPlaceholder": "Código SMS",
      "phoneOtpInvalid": "Introduzca el código de 6 dígitos",
      "phoneOtpConfirm": "Confirmar",
      "phoneOtpResend": "Reenviar código",
      "phoneOtpResendIn": "Reenviar código en {{seconds}}s",
      "phoneOtpChangeNumber": "Cambiar número",
      "phoneOtpCancel": "Cancelar"
    },
    "clientDay": {
      "title": "Elige un día",
      "seeMoreDates": "Ver más fechas",
      "noMoreAvailableDates": "No hay más fechas disponibles",
      "morning": "Mañana",
      "afternoon": "Tarde",
      "evening": "Noche",
      "noAvailability": "No hay disponibilidad para este mes.",
      "viewNextMonth": "Ver el próximo mes"
    },
    "clientPage": {
      "newBooking": "Nueva Reserva",
      "cancelBooking": "Cancelar Reserva",
      "seoTitle": "Reservas Online",
      "seoDescription": "Realiza aquí tu reserva de forma simple y rápida.",
      "footer1": "Sistema gratuito de programación de citas",
      "footer2": "para todos los negocios",
      "canceled": "Cancelado",
      "noshow": "No presentado",
      "see": "Ver",
      "close": "Cerrar"
    },
    "clientProviders": {
      "title": "Selecciona un miembro del personal",
      "title_multi": "Selecciona un miembro del personal para cada uno de los servicios",
      "withoutPreference": "Sin preferencia"
    },
    "clientServices": {
      "title": "Selecciona un servicio",
      "title_multi": "Selecciona los servicios",
      "readMore": "Leer más"
    },
    "clientStores": {
      "title": "Elige una opción"
    },
    "clientSuccess": {
      "title": "Confirmación de reserva",
      "thankYou": "¡Gracias!",
      "paymentCompleted": "El pago se ha realizado con éxito. Recibirá un correo electrónico de confirmación.",
      "addToGoogleCalendar": "Añadir a Google Calendar",
      "addToCalendar": "Añadir a Outlook/Apple Calendar",
      "linkToIcal": "Suscríbete a tu calendario en Outlook, Apple Calendar",
      "mbwayTitle": "Aprove el pago en la aplicación de MBWay",
      "mbwaySuccess": "Tras realizar el pago recibirá un correo electrónico confirmando su reserva.",
      "mbwaySuccessPayOnly": "Tras realizar el pago recibirá un correo electrónico de confirmación.",
      "mbwaySuccessAlert": "En caso de que tu pago no sea exitoso, tu cita será cancelada.",
      "mbSuccessAlert": "Si no realiza el pago en los próximos {{time}}",
      "mbSuccessAlert2": "la reserva no se completará.",
      "mbSuccessStripeAlert": "Esta referencia es válida hasta:",
      "viewPrintableVoucher": "Ver/Imprimir Comprobante",
      "newBooking": "Nueva reserva"
    },
    "clientPayBooking": {
      "alreadyPaid": "La reserva ya está pagada"
    },
    "clientPaySale": {
      "title": "Pagar",
      "alreadyPaid": "Esta venta ya está pagada",
      "payNotAvailable": "El pago online de esta venta no está disponible. Contacte con el negocio para completar el pago.",
      "notFound": "Enlace de pago no encontrado",
      "fallbackSaleName": "Venta",
      "paymentError": "Error al pagar. Por favor, inténtelo de nuevo."
    },
    "clientTime": {
      "title": "Elige una hora",
      "morning": "Mañana",
      "afternoon": "Tarde",
      "night": "Noche"
    },
    "clientEditor": {
      "back": "Agenda",
      "share": "Compartir",
      "edit": "Editar",
      "preview": "Previsualizar",
      "bookingPage": "Página de Reservas",
      "online": "Online",
      "offline": "Offline",
      "pageOffline": "Tu página está offline",
      "pageOfflineText1": "Cuando esté en modo offline, tus clientes no podrán acceder a tu página de reservas.",
      "pageOfflineText2": "¿No quieres recibir reservas a través de tu página de reservas?",
      "pageOfflineText3": "¡No hay problema! Puedes poner tu página en modo offline y seguir gestionando tu negocio internamente a través de la agenda.",
      "pageOfflineText4": "¿Te vas de vacaciones y no quieres recibir reservas temporalmente??",
      "pageOfflineText5": "No necesitas estar offline. Como alternativa, puedes crear un Bloqueo de Tiempo en tu agenda para ese período y así evitar nuevas reservas.",
      "personalize": "Personalizar",
      "moreOptions": "Más Opciones",
      "titleLabel": "Título de la Página",
      "titleMandatory": "El título de la página es obligatorio",
      "bookingPageLink": "Enlace de la Página de Reservas",
      "linkPlaceholder": "Enlace de Reserva",
      "invalidLink": "Enlace inválido",
      "unavailableLink": "Indisponible",
      "availableLink": "Disponible",
      "yourQRCode": "Tu Código QR",
      "yourQRCodeText": "Imprime y coloca un código QR en la entrada de tu tienda",
      "downloadQRCode": "Descargar",
      "personalizeWithYourBrand": "Personaliza con tu marca",
      "yourLogo": "Tu logotipo",
      "removeLogo": "Eliminar",
      "logoFormat": "Formato del logotipo: jpg, png (mín. 640x640px)",
      "coverImage": "Imagen de portada",
      "useDefaultCover": "Usar predeterminado",
      "imageFormat": "Formato de la imagen: jpg, png (mín. 1200x600px)",
      "showTitleOverCoverImage": "Mostrar título sobre la imagen de portada",
      "bookingInstructions": "Instrucciones de Reserva",
      "showBookingInstructions": "Mostrar instrucciones de reserva",
      "font": "Fuente del Título",
      "backgroundColor": "Color de fondo",
      "footerNote": "Notas al pie",
      "websiteAndSocialMedia": "Sitio web y Redes Sociales",
      "facebookPage": "Página de Facebook",
      "facebookPageError": "Por favor, introduce un enlace válido de Facebook (ej: https://facebook.com/username/)",
      "instagramPage": "Página de Instagram",
      "instagramPageError": "Por favor, introduce un enlace válido de Instagram (ej: https://instagram.com/username/)",
      "websiteLink": "Tu sitio web",
      "optionsText": "Opciones personalizadas para tu página de reservas",
      "allowProviderChoice": "Permitir que los clientes elijan un proveedor",
      "allowProviderChoiceText": "Si tienes más de un proveedor, puedes permitir que tus clientes elijan en el momento de hacer la reserva.",
      "allowRandomProviders": "Permitir selección aleatoria de proveedor",
      "allowRandomProvidersText": "Mostrar opción 'Sin preferencia', y el sistema asignará la reserva a un proveedor aleatorio.",
      "serviceCategoryExpanded": "Pestañas de servicios expandidas",
      "serviceCategoryExpandedText": "Si tienes pestañas de servicio, puedes optar por mostrarlas expandidas o colapsadas por defecto.",
      "mandatoryEmailOnBooking": "Correo electrónico obligatorio al reservar",
      "mandatoryEmailOnBookingText": "Exige que tus clientes proporcionen una dirección de correo electrónico al hacer una reserva.",
      "showVatNumberOnBookingPage": "Mostrar campo de NIF en la página de reservas",
      "showVatNumberOnBookingPageText": "Permite que tus clientes agreguen su NIF al hacer una reserva.",
      "showGenderOnBookingPage": "Mostrar campo de Género en la página de reservas",
      "showGenderOnBookingPageText": "Permite que tus clientes agreguen su género al hacer una reserva.",
      "showDOBOnBookingPage": "Mostrar campo de Fecha de Nacimiento en la página de reservas",
      "showDOBOnBookingPageText": "Permite que tus clientes agreguen su fecha de nacimiento al hacer una reserva.",
      "facebookTrackingPixelOrToken": "Rastreo de Facebook",
      "facebookTrackingPixelOrTokenText": "Mejora tus conocimientos añadiendo tu píxel de seguimiento de Facebook y el token de la API de Conversión (opcional) para rastrear tus conversiones.",
      "facebookPixelId": "ID de Pixel de Facebook",
      "facebookPixelIdError": "Por favor, introduce un ID de Pixel de Facebook válido.",
      "facebookConversionToken": "Token de la API de Conversión de Facebook",
      "facebookConversionTokenError": "Por favor, introduce un token válido de la API de Conversión de Facebook, debe ser una cadena alfanumérica",
      "gaPropertyIdBox": "Google Analytics (GA4)",
      "gaPropertyIdBoxText": "Utiliza tu código de seguimiento de Google Analytics para capturar datos de tráfico de reservas online en tu cuenta de Google Analytics.",
      "gaPropertyId": "Tracking ID",
      "gaPropertyIdError": "Por favor, introduzca un ID de Medición de Google Analytics 4 (GA4) válido con el formato G-XXXXXXXX.",
      "gtmPropertyIdBox": "Google Tag Manager (GTM)",
      "gtmPropertyIdBoxText": "Utiliza tu ID de contenedor de Google Tag Manager para capturar datos de tráfico y conversiones de tu página de reservas en tu configuración de GTM.",
      "gtmPropertyId": "ID de contenedor",
      "gtmPropertyIdError": "Por favor, introduzca un ID de contenedor de Google Tag Manager (GTM) válido con el formato GTM-XXXXXXX.",
      "tiktokPixelBox": "TikTok Pixel",
      "tiktokPixelBoxText": "Utiliza tu ID de TikTok Pixel para capturar datos de tráfico y conversiones de tu página de reservas en tu cuenta de TikTok Ads.",
      "tiktokPixelId": "ID del TikTok Pixel",
      "tiktokPixelIdError": "Por favor, introduzca un ID de TikTok Pixel válido (alfanumérico en mayúsculas).",
      "saveSuccess": "Guardado con éxito",
      "confirmClose": "Tienes cambios sin guardar. ¿Estás seguro de que quieres salir sin guardar?",
      "backToEditor": "Volver al Editor",
      "close": "Cerrar",
      "shareOn": "Compartir en",
      "copyShareLink": "Copiar Enlace de Compartir",
      "linkCopied": "Copiado",
      "shareText": "Haz tu próxima reserva en línea! Usa nuestra página de reservas en:",
      "shareReferralLink": "Tu enlace de recomendación",
      "shareReferralVia": "Compartir con tus contactos"
    }
  },
  "CORE": {
    "seo": {
      "title": "BUK | Calendario de Reservas online",
      "description": "Citas online simples y flexibles para tus clientes."
    }
  },
  "SHARED": {
    "setupStoreProducts": {
      "guidanceTitle": "Crea y personaliza los productos disponibles.",
      "addNew": "Nuevo Producto",
      "editProducts": "Editar Productos",
      "productName": "Nombre del producto",
      "invalidproductName": "Nombre del producto inválido",
      "descriptionName": "Descripción del producto",
      "invalidDescription": "Escribe una descripción del producto con un máximo de 500 caracteres",
      "invalidPrice": "Elija un precio",
      "vatRate": "Tasa de IVA",
      "vatRatePlaceholder": "Selecciona la tasa de IVA",
      "invalidVatRate": "Tasa de IVA inválida",
      "confirmTextproduct": "¿Está seguro de que quiere eliminar este producto?",
      "vatExemption": "Exención de IVA",
      "invalidVatExemption": "Por favor selecciona una exención de IVA",
      "emptyState": "Añade un producto para empezar."
    },
    "setupStoreRooms": {
      "guidanceTitle": "Crea y personaliza tus salas o equipos.",
      "emptyState": "Añade una sala o equipo para empezar.",
      "addNew": "Nueva Sala",
      "editRooms": "Editar Salas",
      "roomName": "Nombre de la sala / equipo",
      "invalidRoomName": "Nombre de la sala / equipo inválido",
      "descriptionName": "Descripción de la sala / equipo",
      "invalidDescription": "Descripción inválida",
      "confirmTextRoom": "¿Está seguro de que quiere eliminar esta sala / equipo?",
      "room": "Sala",
      "equipment": "Equipo",
      "services": "Servicios asociados",
      "type": "Tipo",
      "typePlaceholder": "Sala o equipo",
      "servicesPlaceholder": "Seleccione los servicios"
    },
    "close": "Cerrar",
    "help-modal": {
      "title": "¿Necesitas ayuda?",
      "phone": "Teléfono",
      "sms": "SMS",
      "wecanhelp": "Habla con nosotros.",
      "helpCenter": "Centro de Ayuda BUK"
    },
    "signup": {
      "missingEmail": "Por favor, introduce tu correo electrónico",
      "aboutBusiness": "Sobre tu negocio",
      "registerSubTitle": "La información de tu negocio puede ser cambiada más tarde en los ajustes de tu cuenta.",
      "yourAccount": "Tu cuenta",
      "yourBusiness": "Tu negocio",
      "yourBusinessTitle": "¡Registra tu negocio en segundos!",
      "writeYourName": "Escribe tu nombre",
      "yourName": "Nombre y apellidos",
      "writeYourEmail": "Escribe tu correo electrónico",
      "writeYourPhone": "Escribe tu número de teléfono",
      "writePassword": "Elige una contraseña",
      "readTerms1": "He leído y acepto los",
      "readTerms2": "Términos y condiciones",
      "readTerms3": "y la",
      "readTerms4": "Política de Privacidad",
      "register": "Registrarse",
      "alreadyHaveAnAccount": "¿Ya tienes una cuenta?",
      "loginHere": "Inicia sesión aquí.",
      "newCompaniesCampaingCheckboxTitle": "Nuevas Empresas",
      "newCompaniesCampaingDesc": "Usa el plan Pro/Pro+ gratis si registraste tu empresa hace menos de 3 meses.",
      "newCompaniesCampaingCheckbox": "Quiero postularme a la campaña BUK Nuevas Empresas"
    },
    "signup2": {
      "registerAccountSubtitle": "¡y configura tu cuenta en segundos!",
      "registerBusinessTitle": "Registra tu negocio",
      "registerBusinessSubtitle": "Bienvenido/a",
      "orUseEmail": "o usa tu correo electrónico",
      "logout": "Cerrar sesión"
    },
    "login": {
      "login": "Iniciar sesión",
      "emailPlaceholder": "Correo electrónico",
      "emailInvalidMessage": "Correo electrónico inválido",
      "passwordPlaceholder": "Contraseña",
      "passwordInvalidMessage": "Contraseña inválida",
      "ctaLogin": "Iniciar sesión",
      "passwordNotRemember": "¿Has olvidado tu contraseña?",
      "clickHere": "Haz clic aquí.",
      "notRegisteredYet": "¿Aún no tienes una cuenta?",
      "signupHere": "Regístrate aquí."
    },
    "setupMerchantPage": {
      "businessName": "Nombre de tu negocio",
      "invalidBusinessName": "Por favor, introduce el nombre de tu negocio.",
      "slug": "Enlace de reservas",
      "invalidSlug": "Enlace inválido",
      "teamSize": "¿Cuál es el tamaño de tu equipo?",
      "teamSizeText": "Ayúdanos a mejorar tu experiencia 🪄",
      "invalidBusinessType": "Por favor, selecciona el tipo de negocio",
      "unavailableLink": "Enlace no disponible",
      "availableLink": "Enlace disponible",
      "chooseCountry": "Elije un país",
      "country": "País",
      "businessType": "¿Cuál es tu tipo de negocio?",
      "businessTypeText": "Ayúdanos a mejorar tu experiencia 🪄",
      "invalidTeamSize": "El tamaño de equipo no es válido",
      "previousSoftware": "¿Qué software estás utilizando actualmente?",
      "previousSoftwareText": "Si estás pensando en cambiar, podemos ayudarte a acelerar la configuración de tu negocio e importar tus datos a tu nueva cuenta BUK.",
      "discoverChannel": "¿Dónde has oído hablar de BUK?",
      "discoverChannelText": "Ayúdanos a mejorar tu experiencia",
      "otherSoftware": "Otro",
      "noSoftware": "No uso ningún software",
      "friend": "Recomendado por un amigo",
      "madeBooking": "Lo usé para hacer una reserva",
      "search": "Búsqueda en Google",
      "social": "Instagram / Facebook",
      "ad": "En un anuncio online",
      "other": "Otro"
    },
    "setupStoreServices": {
      "guidanceTitle": "Añade tus servicios:",
      "chooseCurrency": "Elige la moneda",
      "serviceName": "Nombre del servicio",
      "serviceImage": "Imagen del servicio",
      "image": "Imagen",
      "changeColor": "Cambiar color",
      "descriptionName": "Descripción del servicio",
      "invalidServiceName": "Escribe un nombre para el servicio",
      "invalidDescription": "Escribe una descripción del servicio con un máximo de 500 caracteres",
      "name": "Nombre",
      "description": "Descripción",
      "duration": "Duración",
      "customDuration": "Editar duración",
      "invalidDuration": "Elige una duración",
      "invalidPrice": "Elija un precio",
      "color": "Color",
      "categoryName": "Nombre de la categoría",
      "invalidCategoryName": "Escriba un nombre para la categoría",
      "addNew": "Nuevo Servicio",
      "addNewCategory": "Nueva Categoría",
      "editCreateServices": "Editar Servicio",
      "editCreateCategory": "Editar Categoría",
      "confirmTextService": "¿Está seguro de que quiere eliminar este servicio?",
      "confirmTextCategory": "¿Está seguro de que quiere eliminar esta categoría?",
      "showOnBookingPage": "Disponible en la página de reservas",
      "showPriceOnBookingPage": "Mostrar precio en la página de reservas",
      "generateVideoCallLink": "Generar enlace de videollamada",
      "generateVideoCallLinkDescription": "Crear automáticamente un único enlace de Google Meet que se compartirá en las reservas de este servicio.",
      "scheduleOverride": "Establecer un horario personalizado",
      "durationExtraConfig": "Personalizar duración del servicio",
      "durationForClient": "Duración para el cliente",
      "durationForProvider": "Duración para el colaborador",
      "options": "Opciones",
      "priceChange": {
        "title": "Elige una opción",
        "description": "Hay {{count}} reservas futuras para este servicio que aún no se han pagado. ¿Quieres aplicar el nuevo precio?",
        "newOnly": "No, aplicar solo a nuevas reservas",
        "alsoFuture": "Sí, aplicar a reservas nuevas y existentes"
      }
    },
    "setupStoreWorkplan": {
      "guidanceTitle": "Configura el horario de trabajo.",
      "openHour": "Inicio",
      "closeHour": "Fin",
      "invalidCloseHour": "Elige una hora de cierre",
      "invalidOpenHour": "Elige una hora de apertura",
      "intervalsOverlap": "Los intervalos del mismo día no se pueden solapar.",
      "deleteHours": "Eliminar intervalo de horas",
      "addHours": "Añadir intervalo de horas",
      "mon": "Lun",
      "tue": "Mar",
      "wed": "Mié",
      "thu": "Jue",
      "fri": "Vie",
      "sat": "Sáb",
      "sun": "Dom",
      "providerWorkplanConflict": "Atención: Este colaborador tiene un horario diferente al horario predefinido en la tienda. Para utilizar el horario de la tienda haga clic",
      "here": "aquí",
      "storeWorkplanConflictSingular": "Aviso: hay {{param}} colaborador con horario diferente de este horario de la tienda. Los cambios que realice en esta página no tendrán efecto en ese colaborador.",
      "storeWorkplanConflict": "Aviso: hay {{param}} colaboradores con horarios diferentes de este horario de la tienda. Los cambios que realice en esta página no tendrán efecto en esos colaboradores.",
      "storeServiceWorkplanConflictSingular": "Aviso: hay {{param}} servicio con horario diferente de este horario de la tienda. Los cambios que realice en esta página no tendrán efecto en ese servicio.",
      "storeServiceWorkplanConflict": "Aviso: hay {{param}} servicios con horarios diferentes de este horario de la tienda. Los cambios que realice en esta página no tendrán efecto en esos servicios.",
      "createExceptions": "Crear horarios especiales"
    },
    "setupStoreProviders": {
      "addNew": "Añadir nuevo",
      "directLink": "Link",
      "editProvider": "Editar colaborador",
      "guidanceTitle": "Registra a tus colaboradores.",
      "invalidNameResource": "Escribe el nombre del colaborador",
      "nameResource": "Nombre del colaborador",
      "newProvider": "Nuevo colaborador",
      "providerNoServicesError": "Por favor, selecciona al menos un servicio",
      "settings": "Seleccione el horario y los servicios de este colaborador(a)",
      "goBack": "Volver atrás",
      "addExistingProvider": "Agregar colaborador de una tienda existente",
      "pickAnOption": "Elige una opción",
      "sharedProviderWarning": "está asociado a varias tiendas. Programar una cita en un calendario impedirá la reserva en los demás.",
      "noProvidersToAdd": "No hay colaboradores disponibles para añadir."
    },
    "setupMultipleServices": {
      "addNew": "Nueva Regla"
    },
    "setupProviderWorkplanModal": {
      "guidanceTitle": "Establece un horario para \"{{name}}\" diferente al horario de operación de la tienda",
      "guidanceTitleNoName": "Define el horario del empleado",
      "schedule": "Horario"
    },
    "setupProviderServicesModal": {
      "guidanceTitle": "Selecciona/Edita los servicios de este empleado",
      "guidanceTitleNoName": "Define los servicios para el empleado",
      "schedule": "Servicios",
      "scheduleOverride": "Establecer un horario personalizado",
      "bookingFrequencyOverride": "Intervalo de reservas personalizado para este empleado",
      "bookingFrequencyBookingPageOnly": "Esta configuración solo afecta a la página de reservas.",
      "bookingFrequencyStoreDefaultHint": "Cuando está desactivado, usa el intervalo de la tienda ({{value}}).",
      "commissions": "Comisiones"
    },
    "setupProviderCommissionsModal": {
      "guidanceTitle": "Selecciona/Edita las comisiones de este colaborador",
      "guidanceTitleNoName": "Define las comisiones para el colaborador"
    },
    "googleConnectAccount": {
      "syncWithGoogleCalendar": "Google Calendar",
      "syncWithGoogleCalendarDescription": "Tus citas aparecerán en tu calendario de Google automáticamente.",
      "syncWithGoogleCalendarError": "No se pudo sincronizar con Google Calendar. Por favor, intente de nuevo.",
      "syncedWith": "Sincronizado con {{email}}",
      "sync": "Sincronizar",
      "stopSync": "Detener",
      "stopEmailSync": "Desconectar",
      "accountDescription": "Sincroniza tu agenda en ambos sentidos: tus eventos de Google bloquean la agenda y las reservas de BUK aparecen en tu calendario de Google.",
      "connectPrompt": "Conecta tu cuenta de Google",
      "configure": "Configurar",
      "sectionDescription": "Las reservas de tu agenda se sincronizarán con tu Google Calendar.",
      "sendTitle": "Enviar a Google",
      "sendDescription": "Las reservas hechas aquí se envían a Google Calendar.",
      "receiveTitle": "Recibir de Google",
      "receiveDescription": "Los eventos ocupados de los calendarios elegidos bloquean horarios aquí.",
      "connect": "Conectar",
      "disconnect": "Desconectar",
      "accountConnected": "Cuenta conectada",
      "connectedBadge": "Conectada",
      "importCalendarsForProvider": "Calendarios a importar para este profesional",
      "importProviderReceives": "Profesional que recibirá los eventos",
      "settingsModalTitle": "Mi conexión con Google",
      "reconnect": "Reconectar",
      "needsReauth": "Necesita reconectar",
      "exportEnabled": "Enviar citas a Google",
      "exportProvidersHint": "Citas de:",
      "exportNote": "Van al calendario “BUK” de tu cuenta de Google.",
      "importEnabled": "Recibir eventos de Google",
      "importCalendarsLabel": "Calendarios a importar",
      "importProviderLabel": "Bloquear la agenda de:",
      "importBlocksAgendaOf": "Bloquea la agenda de {{name}}",
      "importUnavailable": "No hay calendarios de Google ni colaboradores disponibles para recibir eventos.",
      "confirmImportOff": "Al desactivarlo, los bloqueos importados de Google se eliminarán de la agenda. ¿Continuar?",
      "userFeedSubscribe": "Suscribirse a mi agenda (todas las reservas a las que tengo acceso) en Outlook o Apple Calendar",
      "downloadIcs": "Descargar archivo .ics",
      "otherCalendarsButton": "Outlook o Apple Cal",
      "otherCalendarsTitle": "Outlook o Apple Calendar",
      "copyAddress": "Copiar dirección",
      "subscribeLinkLabel": "Dirección de la agenda",
      "addressCopied": "Dirección copiada",
      "movedToAccount": "La sincronización con Google Calendar pasó a Mi cuenta. Aquí queda el enlace iCal de la tienda.",
      "goToAccount": "Ir a Mi cuenta"
    },
    "googleConnectReview": {
      "modalTitle": "Conectar negocio",
      "searchLabel": "Encuentra tu negocio en Google Maps:",
      "testLink": "Probar enlace",
      "saveLink": "Guardar"
    },
    "googleReserve": {
      "title": "Google Reserve",
      "desc": "Atrae a más clientes permitiendo reservas directas a través de Google.",
      "cta": "Configurar",
      "price": "2.99€ / mes",
      "freeUntil": "Gratis hasta 10/2023",
      "activate": "Activar extensión",
      "deactivate": "Desactivar extensión",
      "active": "Activo",
      "inactive": "Inactivo",
      "notBeauty": "Extensión solo disponible para negocios de belleza",
      "askForHelp": "Pedir ayuda",
      "success": "¡Extensión activada! Ten en cuenta que puede tardar hasta 48 horas en surtir efecto.",
      "warning": "Atención, algunos servicios no están disponibles en Google Reserve porque no tienen un precio configurado.",
      "error": "¡Atención! Para activar la extensión debes asignar un precio a tus servicios. Tras asignar un precio a tus servicios, la extensión puede tardar hasta 48 horas en surtir efecto.",
      "modalConfirmDeactivate1": "¡Atención! Al desactivar esta funcionalidad, está perdiendo una herramienta crítica para su negocio.",
      "modalConfirmDeactivate2": "Sus clientes no podrán agendar a través de la integración con Google",
      "modalConfirmActivate1B": "Esta extensión tiene un costo mensual de 2.99€.",
      "modalConfirmActivate1": "Puede activar o desactivar en cualquier momento sin compromiso.",
      "modalConfirmActivate2": "Gratis hasta 10/2023 🥳",
      "modalConfirmActivate2desc": "No se le cobrará hasta el 1 de Octubre de 2023, puede cancelar en cualquier momento desactivando esta funcionalidad.",
      "continue": "Continuar",
      "goBack": "Volver atrás"
    },
    "googleReviews": {
      "title": "Google Reviews",
      "desc": "Envía un mensaje automático a tus clientes para que dejen una reseña en Google después de su visita.",
      "cta": "Configurar",
      "price": "2.99€ / mes",
      "freeUntil": "Gratis hasta 10/2023",
      "activate": "Activar extensión",
      "deactivate": "Desactivar extensión",
      "active": "Activo",
      "inactive": "Inactivo",
      "success": "¡Extensión activa!",
      "modalConfirmDeactivate1": "¡Atención! Al desactivar esta funcionalidad, estás perdiendo una herramienta crítica para tu negocio.",
      "modalConfirmDeactivate2": "Tus clientes no recibirán un mensaje para dejar una reseña en Google después de su visita",
      "modalConfirmActivate1B": "Esta extensión tiene un costo mensual de 2.99€.",
      "modalConfirmActivate1": "Puedes activar o desactivar en cualquier momento sin compromiso.",
      "modalConfirmActivate2": "Gratis hasta 10/2023 🥳",
      "modalConfirmActivate2desc": "No se te cobrará hasta el 1 de Octubre de 2023, puedes cancelar en cualquier momento desactivando esta funcionalidad.",
      "continue": "Continuar",
      "goBack": "Volver atrás"
    },
    "websiteIntegration": {
      "title": "Integración de Sitio Web (Embed)",
      "desc": "Añade una sección de citas en tu sitio web con un código incrustable.",
      "cta": "Configurar"
    },
    "loyaltyPage": {
      "title": "Programa de Fidelización",
      "desc": "Fideliza a tus clientes a través de un sistema de contabilización de puntos/visitas y ofertas promocionales",
      "desc2": "Atención, el programa de fidelización se activa de forma independiente para cada tienda.",
      "cta": "Configurar",
      "inactive": "Inactivo",
      "success": "Ya estás en la lista de espera. Nos pondremos en contacto contigo cuando esta funcionalidad esté disponible.",
      "termsPlaceholder": "El programa de fidelización está abierto a todos los clientes que utilicen nuestros servicios. La participación es voluntaria, y el programa puede ser modificado o terminado en cualquier momento, sin previo aviso.\n\nLas recompensas se otorgan en función del número de visitas o reservas realizadas. Las cancelaciones o ausencias sin previo aviso no se considerarán para el programa. La empresa se reserva el derecho de ajustar las condiciones en caso de abuso.\n\nLas recompensas deben reclamarse en un plazo máximo de 60 días después de su otorgamiento y utilizarse de acuerdo con las reglas definidas por la empresa. Cualquier uso indebido o fuera del plazo puede resultar en la pérdida de las recompensas acumuladas.",
      "visits": "Visitas",
      "visit": "Visita",
      "active": "Activo",
      "deactivate": "Desactivar",
      "cancel": "Cancelar",
      "terms": "Términos y condiciones",
      "invalidTerms": "Términos y condiciones inválidos",
      "configuration": "Configuraciones",
      "configurationDesc": "Configura tu plan de fidelización de acuerdo con tu negocio",
      "invalidValue": "Valor inválido",
      "prizeName": "Nombre del premio",
      "invalidName": "Nombre inválido",
      "defaultName": "50% desconto",
      "faqs": "Preguntas Frecuentes",
      "faqs_q1_es": "¿Cómo funciona el Programa de Fidelización?",
      "faqs_r1_es": "El Programa de Fidelización contabiliza automáticamente cada visita completada por tus clientes. Cuando el cliente alcanza el número de visitas necesarias para el premio, recibe un correo electrónico felicitándolo, junto con las instrucciones para reclamar el premio en su próxima visita.",
      "faqs_q2_es": "¿Qué pasa si el cliente falta a la cita?",
      "faqs_r2_es": "Si el cliente no se presenta – marca <Falta> en la cita, y esa visita no será contabilizada en el programa de fidelización. Solo las visitas que no están marcadas como <Falta> cuentan para el progreso.",
      "faqs_q3_es": "¿Cómo puede el cliente seguir su progreso en el programa?",
      "faqs_r3_es": "Después de cada visita, el cliente recibe un correo electrónico con el número de visitas realizadas hasta el momento, para que pueda seguir fácilmente su progreso hacia el premio.",
      "faqs_q4_es": "¿Cómo recibe el cliente el premio?",
      "faqs_r4_es": "Cuando el cliente alcanza el número de visitas necesarias para obtener el premio, recibe un correo felicitándolo, junto con los detalles del premio.",
      "faqs_q5_es": "¿Cómo identificar las citas con premios en el back office?",
      "faqs_r5_es": "En el back office, las citas que incluyen premios están marcadas con un ícono de trofeo, lo que facilita su identificación. En las citas normales, también puedes ver el conteo de visitas del cliente, indicado también con un ícono de trofeo.",
      "faqs_q6_es": "¿Qué hacer si el cliente no recibe el correo electrónico de seguimiento?",
      "faqs_r6_es": "Si el cliente no recibe el correo electrónico de seguimiento después de su visita, sugerimos que revise su carpeta de spam o correo no deseado. Si el problema persiste, contacta con nuestro equipo de soporte.",
      "visitsDesc": "¿En qué visita recibe el cliente el premio?",
      "prizeNameDesc": "Ej. \"Servicio gratis\", \"Vale de 10€\"",
      "termsDesc": "Este campo se utiliza para comunicar claramente las reglas de su programa de fidelización a sus clientes. Léalo atentamente y adáptelo según sea necesario.",
      "cancelModalTitle": "Desactivar Programa de Fidelización",
      "cancelModalDesc1": "¡Atención! Al desactivar, está interrumpiendo el sistema de recompensas para sus clientes.",
      "cancelModalDesc2": "Todo su progreso será pausado, y sus visitas no serán contabilizadas en el Programa de Fidelización. No olvide informar a sus clientes.",
      "successModalTitle": "¡Genial! El Programa ha sido activado.",
      "successModalDesc1": "Ahora, cada visita será registrada en el Programa de Fidelización. Podrá seguir el progreso a través de los perfiles de los clientes o de las reservas realizadas.",
      "successModalDesc2": "Después de cada visita, el cliente recibe un correo electrónico con el número de visitas realizadas hasta el momento.",
      "prize": "Premio",
      "editPoints": "Edita los puntos de visitas de",
      "editPointsInvalid": "El número de puntos debe ser menor o igual que"
    },
    "rgpdPage": {
      "title": "RGPD Digital",
      "desc": "Organiza los datos de tus clientes a través de un sistema digital bajo la ley de protección de datos.",
      "desc2": "Esta funcionalidad aún no está disponible y tendrá un precio adicional de 2,99 € / mes sobre tu suscripción del plan Pro.",
      "cta": "Configurar",
      "price": "2.99€ / mes",
      "inactive": "Inactivo",
      "success": "Ya estás en la lista de espera. Nos pondremos en contacto cuando sea posible acceder a esta funcionalidad."
    },
    "paymentsPage": {
      "title": "BUK Pay",
      "pageDesc": "Recibe pagos con Stripe: el cliente paga al reservar o cóbralo en la agenda, por enlace o MB WAY.",
      "desc": "Asegura el compromiso de tus clientes, evita ausencias aceptando pagos de adelantos de tus clientes en la reserva a través de MB WAY, tarjeta de crédito, Apple Pay, Google Pay",
      "advantage1": "Pago opcional u obligatorio en el acto de la reserva",
      "advantage2": "Recibe un adelanto para asegurar el cupo. Elige el porcentaje que deseas recibir",
      "advantage3": "Pagos a tu cuenta bancaria al día siguiente",
      "advantage4": "No necesitas una suscripción PRO",
      "percentage": "Porcentaje",
      "fixedValue": "Valor fijo (€)",
      "cta": "Configurar",
      "price": "Comisión 1.9% + 0.50€",
      "comission": "Comisión",
      "comissionFinalDesc": "por pago realizado online.",
      "activate": "Activar",
      "deactivate": "Desactivar",
      "active": "Activo",
      "inactive": "Inactivo",
      "configurated": "Configurada",
      "pending": "Pendiente",
      "notConfigurated": "No configurado",
      "paymentMethods": "Métodos de pago",
      "paymentMethodsAndFees": "Métodos de pago y comisiones",
      "choosePaymentMethods": "Elige los métodos que aceptas.",
      "paymentsStripe": "Tarjeta, Apple Pay / Google Pay",
      "paymentsMBWay": "MBWay",
      "paymentsMBWayDesc": "Contactar ayuda@buk.es",
      "paymentOptions": "Opciones de pago",
      "channelsTitle": "Dónde activar pagos",
      "channelsDesc": "Activa los canales que quieres usar. Puedes combinar ambos.",
      "channelBackofficeTitle": "En la agenda",
      "channelBackofficeDesc": "Pide el pago por MB WAY o envía un enlace para que el cliente pague después.",
      "channelBookingTitle": "En la página de reservas",
      "channelBookingDesc": "El cliente paga al reservar, con prepago o anticipo.",
      "channelRequiresMethod": "Activa al menos un método de pago y configura la cuenta bancaria.",
      "mandatoryPaymentTitle": "Pago adelantado obligatorio",
      "mandatoryPaymentText": "Pago obligatorio para que tu cliente realice la reserva",
      "depositPaymentTitle": "Configurar adelanto",
      "depositPaymentText": "Elige un valor a cobrar a tu cliente por servicio",
      "successMessage": "Configuraciones de pago guardadas con éxito",
      "configPaymentsdWarning": "Configura un método de pago",
      "configStripeWarning": "La configuración de tu cuenta Stripe está incompleta o pendiente. Por favor haz clic en configurar",
      "someServicesDoNotHavePrice": "Tenga en cuenta que algunos servicios no están disponibles para pago porque no tienen un precio fijo",
      "allServicesDoNotHavePrice": "Para activar la extensión debes establecer un precio en tus servicios",
      "faqTitle": "Preguntas Frecuentes",
      "faqTitle1": "¿Cuándo recibo mi dinero de los pagos MBWAY?",
      "faqDesc1": "Los pagos de MBWAY se transferirán a su cuenta de Stripe dentro de los 3 días hábiles posteriores al pago. Luego recibirá en el IBAN proporcionado en Stripe conforme a la periodicidad elegida.",
      "faqTitle2": "¿Qué tengo que pagar?",
      "faqDesc2": "Solo se cobrará una comisión de 1.9% + 0.50€ por transacción en todos los pagos que se realicen a través de tu página de reservas.",
      "faqTitle3": "¿Cómo recibo mi dinero?",
      "faqDesc3": "Todos los pagos serán transferidos al IBAN proporcionado en Stripe con la deducción de la comisión.",
      "faqTitle4": "¿Tienes alguna otra pregunta??",
      "faqDesc4": "Contáctanos en",
      "faqDesc42": "o a través de",
      "faqTitle5": "¿Cómo puedo hacer un reembolso?",
      "faqDesc5": "BUK no realiza reembolsos automáticamente. En caso de cancelación, deberás realizar el reembolso del valor directamente a tu cliente.",
      "faqTitle6": "¿Cuándo recibo mi dinero?",
      "faqDesc6": "Para cambiar la periodicidad (día, semana, mes) de los depósitos, realiza la configuración correspondiente directamente en Stripe.",
      "modalConfirmDeactivate1": "¡Atención! Al desactivar esta funcionalidad, estás perdiendo una herramienta crítica para tu negocio.",
      "modalConfirmDeactivate2": "Tus clientes no podrán realizar pagos en tu página de reservas.",
      "goBack": "Volver atrás",
      "someServiceWithNoPrice": "Tienes un servicio que no tiene precio definido. Para corregir esta situación vaya a Configuraciones > Servicios.",
      "prePaymentOptions": "Opciones de prepago",
      "prePaymentOptionsDesc": "Configure reglas para pagos online como prepago obligatorio o un valor mínimo de anticipo.",
      "prepaymentSummaryRequired": "Obligatorio",
      "prepaymentSummaryDepositPercent": "Anticipo {{percent}}%",
      "prepaymentSummaryDepositAmount": "Anticipo {{amount}} €",
      "prepaymentSummaryNone": "Sin reglas activas",
      "bankAccount": "Cuenta bancaria",
      "bankAccountDesc": "Configure su cuenta bancaria para recibir dinero de sus pagos online.",
      "bankAccountDescChannels": "Conexión a Stripe, común a todos los canales. Aquí recibes el dinero de los pagos.",
      "notConfigured": "No configurado",
      "emailInfo": "Correo electrónico de acceso",
      "bank": "Banco"
    },
    "extensions": {
      "pageTitle": "Extensiones",
      "pageDesc": "Impulsa tu negocio con nuestras extensiones ⚡️",
      "active": "Activo",
      "viewExtensions": "Ver extensiones"
    },
    "teyaTerminal": {
      "title": "Terminal Teya",
      "desc": "Solicita un terminal de pagos Teya y automatiza los pagos en el mostrador.",
      "cta": "Ver más",
      "ctaBoxDesc": "Enviamos el terminal y activamos la integración en menos de 24 horas."
    },
    "navbar": {
      "statistics": "Estadísticas",
      "reports": "Informes",
      "agenda": "Agenda",
      "invoicing": "Facturación",
      "clients": "Clientes",
      "settings": "Configuraciones",
      "marketing": "Marketing",
      "extensions": "Extensiones",
      "help": "¿Ayuda?",
      "subscription": "Suscripción",
      "logout": "Salir",
      "week": "Semana",
      "shareLink": "Compartir",
      "downloadQR": "Download QR Code",
      "linkCopied": "Enlace copiado",
      "editPage": "Editar página",
      "viewPage": "Ver página",
      "usingFreePlan": "Estás utilizando el <strong>Plan Gratis</strong>",
      "mobilePro1": "Activa el Plan PRO",
      "mobilePro2": "Plan PRO: Paga 1 mes, úsalo 3.",
      "mobilePro3": "¡Más funcionalidades y mayor personalización!",
      "becomePro": "SER PRO",
      "pastFreeTrial": "El periodo gratuito ha terminado, para continuar active tu suscripción.",
      "pastDue": "Tu suscripción ha expirado por fallo de pago. Para poder continuar disfrutando de todas las funcionalidades de BUK corrija su método de pago.",
      "activateSubscription": "Activar suscripción",
      "trialingDaysLeft": "Quedan <strong>{{trialingDaysLeft}} días</strong> para terminar tu período gratuito. Para continuar después de este período activa tu suscripción.",
      "ignore": "Ignorar",
      "subscriptionCancelled": "Tu suscripción fue cancelada. Actívela para poder continuar usando todas las funcionalidades de Buk",
      "freePlanBanner": "Psst... Ahora existe un nuevo Plan Profesional para 1 colaborador. 👀",
      "seePlan": "Ver Plan",
      "shareOn": "Compartir en",
      "copyCode": "Copiar enlace",
      "shareText": "Obtén un 50% de descuento durante 6 meses en cualquier plan PRO de BUK - Sistema de Reservas Online - con mi código:",
      "timeAgo": "hace {{value}}",
      "bookDemo": "Reservar ",
      "bookDemo2": "Demo",
      "addToHomescreenCta": "Añadir a la pantalla de inicio",
      "addToHomescreenCtaSubtitle": "Crea un acceso directo en tu pantalla principal",
      "sales": "Ventas"
    },
    "addToHome": {
      "title": "Añadir a la pantalla de inicio",
      "ios1": "Accede a tu agenda y haz clic en el botón de compartir en la barra de direcciones.",
      "ios2": "En la lista de opciones de compartir, debajo de las sugeridas, elige “Añadir a la pantalla de inicio” o “Add to Home screen”.",
      "android1": "Accede a tu agenda y haz clic en el botón de “más opciones”.",
      "android2": "En la lista de opciones de compartir, debajo de las sugeridas, elige “Añadir a la pantalla de inicio” o “Add to Home screen”."
    },
    "selectStore": {
      "invite": "Plan PRO gratis",
      "subscription": "Suscripción",
      "logout": "Salir",
      "new": "Nueva",
      "account": "Mi cuenta",
      "help": "Ayuda",
      "addNewStore": "Nueva Tienda o Calendario"
    },
    "addStore": {
      "title": "Agregar",
      "storeNameLabel": "Nombre de la Tienda",
      "storeNamePlaceholder": "Nombre",
      "storeNameInvalidMessage": "Por favor introduce el nombre del establecimiento.",
      "addressLabel": "Dirección",
      "addressPlaceholder": "Dirección",
      "addressInvalidMessage": "Por favor introduce la dirección.",
      "ctaCancel": "Cancelar",
      "ctaCreate": "Crear"
    },
    "confirmDeleteRecurrence": {
      "title": "Estás eliminando un evento recurrente.",
      "deleteOnlyThis": "Eliminar solo este",
      "deleteAll": "Eliminar todos"
    },
    "confirmDeleteMultiple": {
      "title": "Estás eliminando un evento con múltiples servicios.",
      "deleteOnlyThis": "Eliminar solo este servicio",
      "deleteAll": "Eliminar todos"
    },
    "confirmRemoveProvider": {
      "title": "Eliminar",
      "cancelAll": "Eliminar y cancelar citas",
      "notifyClient": "Notificar a los clientes de la cancelación",
      "transferTo": "Transferir a",
      "desc1": "Este colaborador todavía tiene 1 cita, ¿cómo desea proceder?",
      "desc2": "Este colaborador todavía tiene {{bookings}} citas, ¿cómo desea proceder?"
    },
    "createBookingModal": {
      "newBooking": "Nueva cita",
      "editBooking": "Editar cita",
      "booking": "Cita",
      "openVideoCall": "Abrir videollamada",
      "multiBooking": "Esta cita forma parte de una secuencia",
      "pastBookingWarning": "Atención: Estás gestionando una cita en el pasado.",
      "newClientWarning": "Sin cliente seleccionado. Se creará una nueva ficha de cliente.",
      "bookingOutOfBusinessHours": "Atención: Cita fuera del horario laboral.",
      "bookingConflictHours": "Atención: El colaborador ya tiene una reserva en este horario.",
      "bookingRoomEquipmentConflictHours": "Atención: Esta sala/equipo está ocupada en este horario.",
      "service": "Servicio",
      "selectServiceInvalid": "Por favor, selecciona un servicio",
      "selectServicePlaceholder": "Elige un servicio",
      "client": "Cliente",
      "clientPlaceholder": "Nombre del cliente",
      "clientInvalid": "Por favor, indica el nombre del cliente",
      "clientNameMaxLength": "El nombre del cliente debe tener como máximo 255 caracteres",
      "phoneLabel": "Móvil",
      "emailLabel": "Correo electrónico",
      "emailPlaceholder": "Correo del cliente",
      "emailInvalid": "Por favor, indica el correo del cliente",
      "vatNumberLabel": "NIF",
      "vatNumberPlaceholder": "NIF del cliente",
      "vatNumberInvalid": "Por favor indique el NIF del cliente",
      "providerLabel": "Colaborador",
      "providerPlaceholder": "Elija un colaborador",
      "providerInvalid": "Por favor seleccione un colaborador",
      "notesLabel": "Observaciones",
      "notesPlaceholder": "Observaciones",
      "hourPlaceholder": "Hora",
      "hours": "Horas",
      "hour": "Hora",
      "minutes": "Minutos",
      "hourInvalid": "Por favor seleccione una hora",
      "durationPlaceholder": "Duración",
      "duration": "Duración",
      "durationInvalid": "Por favor seleccione la duración",
      "notifyClient": "Notificar cliente",
      "sendPaymentLink": "Incluir enlace de pré-pago",
      "repeatBooking": "Repetir cita",
      "frequency": "Frecuencia",
      "until": "Hasta",
      "saveBooking": "Guardar",
      "createBooking": "Crear cita",
      "deleteBooking": "Eliminar",
      "everyWeek": "Todas las semanas",
      "everyNWeek": "Cada {{N}} semanas",
      "monthlyOnDay": "Mensualmente el día {{day}}",
      "monthlyOnNthWeekday": "Mensualmente el {{ordinal}} {{weekday}}",
      "monthlyOnNthWeekdayMasculine": "Mensualmente el {{ordinal}} {{weekday}}",
      "monthlyOnLastWeekday": "Mensualmente el último {{weekday}}",
      "monthlyOnLastWeekdayMasculine": "Mensualmente el último {{weekday}}",
      "recurrenceOrdinal": {
        "1": "1.er",
        "2": "2.º",
        "3": "3.er",
        "4": "4.º"
      },
      "recurrenceOrdinalMasculine": {
        "1": "1.er",
        "2": "2.º",
        "3": "3.er",
        "4": "4.º"
      },
      "recurrenceWeekday": {
        "0": "domingo",
        "1": "lunes",
        "2": "martes",
        "3": "miércoles",
        "4": "jueves",
        "5": "viernes",
        "6": "sábado"
      },
      "date": "Fecha",
      "notifyClientConfirm": "¿Deseas notificar al cliente del cambio de horario??",
      "chooseCountry": "Buscar país...",
      "addService": "Más servicios",
      "missedBooking": "Inasistencia",
      "notMissedBooking": "Asistido",
      "moreFields": "Más campos",
      "lessFields": "Menos campos",
      "toBePaid": "Por pagar",
      "paidOnline": "Pagado online",
      "created": "Creada",
      "source": {
        "backOffice": "via Backoffice",
        "googleReserve": "via Google Reserve",
        "bookingPage": "via Online"
      },
      "paymentMethods": {
        "money": "Dinero",
        "mbway": "MBWay",
        "ccard": "Tarjeta de crédito",
        "googlepay": "Google Pay",
        "applepay": "Apple Pay",
        "paypal": "Paypal",
        "mbref": "Multibanco",
        "null": "-"
      },
      "pay": "Pagar",
      "saleRecord": "Registro de venta",
      "collectedPayments": "Pagos registrados",
      "totalPaid": "Total pagado",
      "prePaymentLink": "Enlace de prepago",
      "seeRegister": "Ver registro",
      "roomEquipment": "Sala / Equipo",
      "selectRoomEquipmentPlaceholder": "Sin sala / equipo"
    },
    "createInvoiceModal": {
      "invoice": "Emitir factura",
      "invoiceCta": "Faturar",
      "terminalPay": "Pagar",
      "vat": "NIF (opcional)",
      "paymentMethod": "Método de pago",
      "emailLabel": "Correo electrónico del cliente (opcional)",
      "emailPlaceholder": "Correo electrónico del cliente",
      "nameLabel": "Nombre del cliente (opcional)",
      "namePlaceholder": "Nombre del cliente",
      "addService": "Añadir Servicio",
      "invalidVat": "El contribuyente introducido no es válido",
      "isentionReason": "Motivo de exención de IVA",
      "newSale": "Nueva Venta"
    },
    "SIMPLE_PAYMENT_MODAL": {
      "amountLabel": "Importe a cobrar",
      "amountPlaceholder": "0,00",
      "bookingAmount": "Importe de la reserva",
      "method": "Método",
      "sendToTerminal": "Enviar al terminal",
      "teyaTerminal": "Terminal Teya",
      "sendPaymentLink": "Enviar enlace",
      "paymentLinkHint": "BUK Pay",
      "sendMbWayRequest": "Enviar pedido MB Way",
      "mbWayRequestHint": "Pedido MB Way",
      "activateTerminal": "Activar Terminal",
      "activateTerminalHint": "Conecta el terminal Teya para cobrar en este dispositivo.",
      "activateBukPay": "Activar BUK Pay",
      "activateBukPayHint": "Activa los pagos online para enviar enlaces BUK Pay.",
      "activateMbWay": "Activar MB Way",
      "activateMbWayHint": "Activa los pagos online para enviar pedidos MB Way.",
      "methodNotActive": "Este método aún no está activo",
      "emailLabel": "E-mail",
      "emailPlaceholder": "Email del cliente",
      "emailHelper": "Se enviará un enlace de pago a este e-mail.",
      "phoneLabel": "Móvil",
      "phoneHelper": "Se enviará un pedido de pago MB Way a este número.",
      "invoiceAfterPayment": "La factura se emite cuando el cliente complete el pago.",
      "notUsingYet": "Aún no usas en BUK",
      "salesModuleTitle": "Gestión de ventas",
      "salesModuleDescription": "Registra ventas, pagos parciales e historial del cliente.",
      "invoicingModuleTitle": "BUK Facturación",
      "invoicingModuleDescription": "Emite facturas certificadas a partir de los cobros.",
      "linkSent": "Enlace de pago enviado",
      "mbwaySent": "Pedido MB Way enviado",
      "waitingMbWayApproval": "Esperando la aprobación en la app MB Way…",
      "waitingPayment": "Esperando el pago en el terminal",
      "paymentReceived": "Pago recibido",
      "paymentFailed": "El pago ha fallado",
      "paymentFailedDescription": "No se pudo completar el pago. Puede intentarlo de nuevo.",
      "paymentTimeout": "Se agotó el tiempo de espera del pago",
      "send": "Enviar",
      "invoiceTitle": "Emitir factura",
      "invoiceDescription": "Ahorre tiempo con el módulo de Facturación Buk: emita facturas certificadas a partir de los cobros.",
      "learnMore": "Saber más"
    },
    "createHolidayModal": {
      "title": "Bloquear Citas",
      "startDateLabel": "Inicio",
      "endDateLabel": "Fin",
      "providerLabel": "Colaborador",
      "providerPlaceholder": "Selecciona un colaborador",
      "providerInvalid": "Por favor selecciona un colaborador",
      "reasonLabel": "Observaciones",
      "reasonPlaceholder": "Observaciones",
      "reasonMaxLength": "Las observaciones deben tener como máximo 500 caracteres",
      "recurrentEvent": "Evento recurrente",
      "repeatLabel": "Repetir",
      "until": "Hasta",
      "ctaSave": "Guardar",
      "ctaBlock": "Bloquear",
      "ctaDelete": "Eliminar",
      "everyWeek": "Todas las semanas",
      "everyNWeek": "Cada {{N}} semanas",
      "invalidEndDate": "La fecha de fin debe ser después de la fecha de inicio",
      "allProviders": "Todos los colaboradores",
      "googleTitle": "Evento de Google Calendar",
      "googleReadOnly": "Este bloqueo viene de Google Calendar y solo se puede cambiar allí.",
      "googleBroken": "La conexión con Google dejó de funcionar.",
      "googleOrigin": "Origen: Google Calendar",
      "openInGoogle": "Editar en Google Calendar",
      "googleReconnectCta": "Vuelve a conectar Google Calendar."
    },
    "paymentFlashCampaignModal": {
      "header": "PROMOCIÓN LIMITADA 72H",
      "nextPayment": "Próximo pago:",
      "offerEndsIn": "Oferta expira en",
      "onlyAvailable": "Solo disponible en MBWay",
      "pay": "Pagar",
      "title1": "Plan Pro 3 meses",
      "title2": "¡por el precio de 1!",
      "payNow": "Pagar ahora",
      "aboutPROPlan": "Sobre el Plan Pro"
    },
    "paymentModal": {
      "title": "Activar plan",
      "noAccess": "Solo el administrador de la cuenta puede gestionar la suscripción. Contacte con el administrador para corregir el método de pago.",
      "validUntil": "Válido hasta",
      "couponCode": "Código de Descuento",
      "couponCodePlaceholder": "Insertar Código de Descuento",
      "couponCodeInvalid": "Código de Descuento inválido",
      "activate": "Activar",
      "changeCard": "Cambiar tarjeta",
      "changePaymentMethod": "Cambiar método de pago",
      "creditCardNumberLabel": "Tarjeta",
      "sepaName": "Nombre del titular de la cuenta",
      "invalidSepaName": "Nombre del titular de la cuenta inválido",
      "sepaLabel": "IBAN",
      "changeSepa": "Cambiar IBAN",
      "mandateAcceptance": "Al proporcionar la información de pago y confirmar este pago, autoriza (A) a Untold Ventures, Lda y a Stripe, nuestro proveedor de servicios de pago y/o a PPRO, su proveedor de servicios local, a enviar instrucciones a su banco para debitar su cuenta y (B) al banco a debitar su cuenta de acuerdo con estas instrucciones. Como parte de sus derechos, tiene derecho a un reembolso por parte del banco bajo los términos y condiciones del acuerdo con su banco. Un reembolso debe ser solicitado dentro de 8 semanas desde la fecha en que se debito la cuenta. Sus derechos se explican en una declaración que puede obtener de su banco. Usted acepta recibir notificaciones de futuros débitos hasta 2 días antes de que ocurran.",
      "stripeIncorrectNumber": "El número de tarjeta es incorrecto.",
      "stripeInvalidNumber": "El número de tarjeta no es válido.",
      "stripeinvalidExpiryNumber": "El mes de expiración de la tarjeta es inválido.",
      "stripeInvalidExpiryYear": "El año de expiración de la tarjeta es inválido.",
      "stripeInvalidCVC": "El código de seguridad es inválido.",
      "stripeExpiredCard": "La tarjeta ha expirado.",
      "stripeIncorrectCVC": "El código de seguridad es incorrecto.",
      "stripeIncorrectZip": "El código postal no ha pasado la validación.",
      "stripeCardDeclined": "La tarjeta fue rechazada.",
      "stripeMissing": "El cliente no tiene una tarjeta asociada.",
      "stripeProcessingError": "Hubo un error en el procesamiento de la tarjeta.",
      "successPayment": "Pago recibido 🎉 Tu plan ya está activo. ¡Buenas citas!",
      "successPaymentTitle": "Pago recibido 🎉",
      "successPaymentMsg": "¿Sabías que puedes invitar a amigos y ganar 100€?",
      "successPaymentMsg2": "Ahorra en tu suscripción y ofrece un descuento a un amigo que tenga un negocio.",
      "successPaymentInviteFriends": "Invita amigos",
      "vatNumber": "NIF (opcional)",
      "vatNumberPlaceholder": "NIF",
      "vatNumberInvalid": "NIF inválido (ej: {{value}}999999999)",
      "successUpdatePaymentMethod": "Método de pago actualizado",
      "successDiscountCode": "¡Código de descuento aplicado con éxito!",
      "backToCalendar": "Volver al calendario",
      "mbwayNotification1": "Recibirás una notificación en la app MBWay para realizar el",
      "mbwayNotification2": "pago de",
      "sepaNotAllowed": "Este método de pago no está disponible debido al alto número de intentos de cobro fallidos. Por favor, utiliza otro método de pago.",
      "phoneMbway": "Número de MBWay",
      "pay": "Pagar",
      "backToPlans": "Ver planes",
      "plan": "Plan {{value}}",
      "youAreSaving": "Estás ahorrando",
      "paymentMethod": "Método de pago",
      "paymentPeriod": "Periodo de suscripción",
      "vat": "IVA",
      "totalMonthly": "Total Mensual",
      "totalYearly": "Total Anual",
      "subscription": "Suscripción",
      "payNow": "Pagar ahora",
      "cancel": "Cancelar",
      "waitingMBWayPayment": "Esperando el pago MBWay...",
      "authorizeMBWayPayment": "Autoriza el pago en tu teléfono móvil",
      "waitingPayment": "Esperando el pago...",
      "mbrefEntity": "Entidad:",
      "mbrefReference": "Referencia:",
      "mbrefAmount": "Importe:",
      "referralText": "¡Descuento por recomendación aplicado!",
      "referralText2": "50% de descuento durante 6 meses",
      "referralDiscount": "Descuento (Recomendación)",
      "errorCoupon": "El código de descuento introducido no es válido.",
      "discountCodeLabel": "Descuento (Código)",
      "discountApplied": "Descuento aplicado!",
      "for": "durante",
      "months": "mes(es)"
    },
    "discountCodePage": {
      "howManyProviders": "¿Cuántos colaboradores?"
    },
    "plansModal": {
      "title": "Suscripción",
      "planUsing": "Estás disfrutando del",
      "planName": "Plan {{nickname}}",
      "free": "Gratis",
      "professional": "Pro",
      "professionalPlus": "Pro+",
      "planBookingPage": "Página de reservas",
      "planOnlineAgenda": "Agenda Online",
      "planEmailReminders": "Recordatorios por correo electrónico ilimitados",
      "planEmailReminders100": "Recordatorios por correo electrónico (100 gratis / mes)",
      "plan1Provider": "1 Colaborador",
      "planStats": "Estadísticas",
      "syncGoogleCalendar": "Sincronización con Google Calendar",
      "planSMSReminders": "Recordatorios por SMS",
      "activePlan": "PLAN ACTIVO",
      "cancelSubscription": "CANCELAR SUSCRIPCIÓN",
      "haveMoreThanPossibleProviders": "Tienes {{numberOfProviders}} colaboradores activos, este plan solo permite un colaborador.",
      "activatePlan": "CONTINUAR",
      "useBukWithoutLimits": "Usa BUK sin límites con el Plan Pro.",
      "until": "Hasta",
      "provider": "Colaborador",
      "providers": "Colaboradores",
      "haveMoreThanNPossibleProviders": "Tienes {{numberOfProviders}} colaboradores activos y el plan seleccionado sólo permite {{providersAmount}}, <b>para continuar tienes que eliminar colaboradores.</b>",
      "chooseProvidersToRemove": "Elegir colaboradores para eliminar",
      "forMoreThan": "Para más de",
      "contactUs": "ponte en contacto con nosotros por",
      "or": "o",
      "downgradeToFree": "¿Estás seguro de que quieres continuar? Perderás todas las funcionalidades del Plan Profesional.",
      "downgradeFromProPlus": "¿Estás seguro de que quieres continuar? Perderás las funcionalidades exclusivas del Plan Pro+:",
      "with-sms": "Con SMS",
      "without-sms": "Sin SMS",
      "annual-plan": "Anual",
      "paid-annual-plan": "Anual (-20%)",
      "paid-monthly-plan": "Mensual",
      "credit-card": "Tarjeta de Crédito",
      "direct-debit": "Débito Directo"
    },
    "upgradePlanModal": {
      "title": "Cambiar plan",
      "toAdd": "Para añadir",
      "moreProviders": "más colaboradores",
      "needToUpdatePlan": "necesitas actualizar tu plan actual.",
      "toSync": "Para usar la sincronización con",
      "toUse": "Para usar",
      "toSee": "Para ver",
      "seePlans": "Ver más planes",
      "ctaUpdatePlan": "Cambiar ahora",
      "recurringAppointment": "la función de citas recurrentes",
      "stats": "estadísticas",
      "posSettings": "integración de facturación",
      "multiBooking": "la función de reserva de múltiples servicios",
      "sms": "recordatorios SMS",
      "customBookingPage": "la Página de reservas personalizada",
      "footerNote": "personalización del mensaje del pie de página",
      "calendarSettings": "las configuraciones del calendario",
      "customEmail": "la personalización de correos electrónicos",
      "serviceCategory": "categorías de servicios",
      "serviceImage": "imágenes de los servicios",
      "googleReserve": "Google Reserve",
      "googleReviews": "Google Reviews",
      "websiteEmbed": "la Integración en tu sitio web (incrustable)",
      "needToUpdatePlanToPlus": "necesitas actualizar tu plan actual al Plan Pro+."
    },
    "chooseBookOrBlockModal": {
      "newAppointment": "Nueva Cita",
      "blockTime": "Bloquear Citas",
      "teyaSoloPay": "Pago en terminal"
    },
    "chooseProvidersToRemoveModal": {
      "title": "Elegir colaboradores para eliminar",
      "subtitle": "Selecciona los colaboradores que quieres eliminar para continuar con la selección de tu plan",
      "loadingProviders": "Cargando colaboradores...",
      "warningMessage": "<b>Atención! Al eliminar colaboradores:</b><br/>- Tus citas desaparecerán<br/>- Los usuarios perderán el acceso",
      "goBack": "Volver atrás",
      "removeNow": "Eliminar ahora",
      "successTitle": "Colaboradores eliminados con éxito",
      "successMessage": "Los colaboradores seleccionados fueron eliminados con éxito. Ahora ya puedes actualizar tu suscripción.",
      "viewPlans": "Ver planes",
      "errorLoadingProviders": "Error al cargar colaboradores. Inténtalo de nuevo.",
      "errorRemovingProviders": "Error al eliminar colaboradores. Inténtalo de nuevo."
    },
    "userRoles": {
      "admin": "Administrador",
      "admin_note": "[acceso general a todas las Tiendas, Menús y Configuraciones]",
      "manager": "Gerente",
      "manager_note": "[acceso limitado solo a esta Tienda, sin acceso al menú de Estadísticas]",
      "store": "Ordenador de la Tienda",
      "provider": "Colaborador",
      "provider_note": "[acceso limitado solo a una agenda]"
    },
    "googleMeet": {
      "title": "Google Meet",
      "desc": "Envía a tus clientes un enlace de videollamada de Google Meet en las reservas online.",
      "cta": "Configurar"
    }
  },
  "ONBOARD": {
    "setupStoreSuccess": {
      "doneTitle": "¡Ya está! 🎉",
      "guidanceTitle": "¡Genial! Ahora solo tienes que compartir el enlace de tu Página de Reservas con tus clientes.",
      "viewPage": "Ver página",
      "copyLink": "Copiar enlace",
      "linkCopied": "Enlace copiado"
    },
    "step1Title": "¡Bienvenido a tu agenda digital! 🎉",
    "step1Text": "Aquí es donde puedes gestionar tus citas. Accede a tu agenda digital en cualquier momento y lugar a través de tu ordenador o móvil.",
    "step2Title": "Personaliza tu página de reservas",
    "step2Text": "Haz clic en tu enlace de reservas en el menú principal y personaliza tu página a la imagen de tu negocio.",
    "step3Title": "¡Comparte tu enlace con tus clientes!",
    "step4Title": "¡Agenda una demostración con nuestro equipo!",
    "step4Text": "Si tienes alguna duda sobre tu agenda online, contáctanos o agenda una demostración gratuita.",
    "step4Help1": "¿Necesitas ayuda??",
    "step4Help2": "Tlf. / Whatsapp: 988 80 91 64 o apoyo@buk.es",
    "btnContinue": "Continuar",
    "btnExplore": "Explorar agenda",
    "bookADemoBtn": "Habla con nosotros",
    "watchDemoBtn": "Ver demostración"
  },
  "DASHBOARD": {
    "activate": "Activar",
    "deactivate": "Desactivar",
    "updateAvailable": "Actualización necesaria, haz clic aquí.",
    "teyaSetupPage": {
      "companyData": "Datos de la empresa",
      "companyDataDesc": "Utilizamos estos datos para preparar el contrato y la entrega del terminal Teya.",
      "contractData": "Datos para el contrato",
      "contractDataDesc": "Identificación de la empresa y estimación del volumen de pagos con tarjeta.",
      "deliveryAddress": "Dirección de entrega del terminal y las tarjetas",
      "deliveryAddressDesc": "Dónde enviamos el terminal y, si te unes a la Cuenta Teya Business, las tarjetas.",
      "companyName": "Nombre de la empresa",
      "companyNamePlaceholder": "Introduce el nombre de la empresa",
      "vatNumber": "Número de IVA",
      "vatNumberPlaceholder": "Introduce el número de IVA",
      "phoneNumber": "Número de teléfono",
      "phoneNumberPlaceholder": "Introduce el número de teléfono",
      "email": "Correo electrónico",
      "emailPlaceholder": "Introduce el correo electrónico",
      "invoicingDesc": "Solo pagos con tarjeta, no los ingresos totales del salón. Sugerido a partir de las ventas de Buk (menos una parte en efectivo); ajústalo si tu realidad es diferente.",
      "monthlyCardVolume": "Facturación mensual con tarjeta",
      "monthlyCardVolumePlaceholder": "Selecciona la facturación mensual con tarjeta",
      "contractType": "Elige la modalidad",
      "contractTypeDesc": "Selecciona un plan de tarifas y dónde quieres recibir los pagos.",
      "cashback": "cashback",
      "noMonthlyFee": "Sin cuota mensual",
      "perMonth": "/mes",
      "settlementIn": "Liquidación en",
      "teyaBusinessAccount": "Cuenta Teya Business",
      "teyaBusinessAccountInfoTitle": "¿Qué es la Cuenta Teya Business?",
      "teyaBusinessAccountInfoDesc": "Al recibir los pagos en una Cuenta Teya Business, tienes acceso a una tarjeta de débito con un 0,5% de cashback en compras — que ayuda a compensar la cuota mensual elegida.",
      "ownBankAccount": "Tu cuenta bancaria",
      "fewTransactionsDescription": "Ideal para negocios con pocas transacciones: evita la cuota mensual pagando una pequeña tarifa fija por transacción.",
      "manyTransactionsDescription": "Ideal para negocios con muchas transacciones pequeñas: la cuota mensual se reparte entre las transacciones y el cashback ayuda a compensarla.",
      "ownBankDescription": "Para quienes prefieren mantener el dinero en su cuenta bancaria habitual, sin el cashback de Teya Business.",
      "personalCredit": "Crédito particular",
      "businessOrInternational": "Empresarial o internacional",
      "personalDebit": "Débito particular",
      "amexAndOtherCards": "AMEX y otras tarjetas",
      "yourPlan": "Su plan:",
      "plans": {
        "simple": "Teya Simple",
        "advanced": "Teya Advanced",
        "premium": "Teya Premium",
        "private": "Teya Private"
      },
      "perTransaction": "/tx",
      "terminalFee": "Terminal",
      "terminalCharged": "Cobrado",
      "terminalOffered": "Ofrecido",
      "terminalHalfPrice": "50% de descuento",
      "terminalHalfPriceNote": "* 50% de descuento en el terminal; oferta total sujeta a aprobación.",
      "selected": "Seleccionado",
      "choose": "Elegir",
      "address": "Dirección",
      "addressPlaceholder": "Introduce la dirección",
      "postalCode": "Código postal",
      "postalCodePlaceholder": "Introduce el código postal",
      "city": "Ciudad",
      "cityPlaceholder": "Introduce la ciudad",
      "terminalType": "Elige tu terminal",
      "terminalTypeDesc": "Todos los terminales aceptan tarjetas, contactless y llegan configurados para BUK.",
      "vatIncluded": "+ IVA",
      "printer": "Impresora",
      "chooseTerminal": "Elegir terminal",
      "terminalDescriptions": {
        "teya_pro": "Diseño elegante, batería duradera e impresora integrada.",
        "teya_go": "Ligero, fiable e ideal para negocios en movimiento.",
        "teya_lite": "Nuestro terminal más compacto, pensado para mostradores pequeños y negocios siempre en movimiento."
      },
      "li1": "Integrado con el sistema de ventas de BUK.",
      "li2": "Cero errores de caja: elimina las discrepancias entre los informes de BUK y del terminal.",
      "li3": "Cobro rápido: reduce el tiempo de atención en caja al cerrar la reserva.",
      "ctaBoxTitle": "¿Aún no tienes un terminal de pagos Teya?",
      "oauthTitle": "Iniciar sesión en Teya",
      "oauthDesc": "Después del inicio de sesión, BUK elige el terminal asociado a tu cuenta — en la mayoría de los casos solo hay uno.",
      "oauthCta": "Iniciar sesión en Teya",
      "oauthConnectedTitle": "Cuenta Teya",
      "oauthConnectedDesc": "Sesión iniciada con éxito",
      "cloudModeInstructions": "Para mantener la conexión con BUK, el terminal debe estar en <b>modo cloud</b>. En el terminal: Menú → Integraciones POS (al final del menú) → Comunicación en la nube → Salir del menú.",
      "disconnectCta": "Cerrar sesión",
      "terminalsTitle": "Terminal",
      "terminalsDesc": "Elige el terminal de esta cuenta Teya que quieres utilizar para las ventas de BUK.",
      "terminalLabel": "Terminal asociado",
      "saveTerminalsBtn": "Guardar",
      "activateTeya": "Unirse a Teya",
      "sendRequest": "Enviar solicitud",
      "requestSent": "¡Solicitud enviada!",
      "requestSentDescription": "Hemos recibido tu solicitud para unirte a Teya. Nuestro equipo la revisará y te enviará una propuesta en breve.",
      "responseTime": "Tiempo de respuesta típico: hasta 48 horas.",
      "conclude": "Finalizar",
      "awaitingProposal": "Esperando una propuesta",
      "awaitingProposalDesc": "Hemos recibido tu solicitud de adhesión. Nuestro equipo se pondrá en contacto contigo en breve.",
      "monthlyCardVolumeOptions": {
        "under_2500": "Menos de 2 500 €",
        "2500_5000": "Entre 2 500 € y 5 000 €",
        "5000_10000": "Entre 5 000 € y 10 000 €",
        "10000_15000": "Entre 10 000 € y 15 000 €",
        "15000_30000": "Entre 15 000 € y 30 000 €",
        "30000_50000": "Entre 30 000 € y 50 000 €",
        "over_50000": "Más de 50 000 €"
      },
      "settlementAccountOptions": {
        "teya_business": "Cuenta empresarial Teya",
        "own_bank": "Cuenta bancaria propia"
      },
      "terminalOptions": {
        "teya_pro": "Teya Pro",
        "teya_go": "Teya Go",
        "teya_lite": "Teya Lite"
      }
    },
    "referralPage": {
      "title": "Invita a tus amigos <br/>& Gana 100€",
      "subtitle": "Ofrece un 50% de descuento a tus amigos y recibe 50€ en créditos de Marketing + 50€ de crédito en tu suscripción.",
      "cta": "Invitar amigos",
      "ctaSubtitle": "Gana 100€ / invitación",
      "viewReferrals": "Mis referidos",
      "viewRewards": "Mis recompensas",
      "box1": "Difunde la palabra compartiendo tu enlace de referido o mediante compartición en redes sociales",
      "box2": "Tu amigo se suscribe a cualquier plan PRO de BUK con un 50% de descuento durante 6 meses",
      "box3": "Tú recibes 50€ en créditos de Marketing + 50€ de crédito en tu suscripción",
      "title2": "Sigue invitando y sigue ganando",
      "subtitle2": "Tú ganas, tus amigos ganan. No hay límite de invitaciones.",
      "faqQ1": "¿Cómo puedo unirme al programa?",
      "faqA1": "No necesitas unirte. Haz clic en 'Invitar amigos' y comparte tu enlace de invitación.",
      "faqQ2": "¿Cómo recibo recompensas?",
      "faqA2": "El día que tu amigo pague por cualquier plan Pro, obtienes 50€ en créditos de marketing + 50€ de descuento en tu próximo pago de suscripción.",
      "faqQ3": "¿Cuántos amigos puedo invitar?",
      "faqA3": "No hay límite de invitaciones. ¡Cuanto más invites, más probabilidades tienes de ganar!",
      "faqQ4": "¿Cómo sé si mis amigos han pagado?",
      "faqA4": "Utiliza la sección de abajo para seguir cuántos de tus amigos han registrado su negocio y tus recompensas.",
      "yourReferrals": "Tus referidos",
      "yourRewards": "Tus recompensas",
      "registered": "Registrado",
      "added": "Añadido",
      "inMarketing": "en Marketing",
      "inSubscriptionCredit": "en Crédito de Suscripción",
      "emptyReferrals": "Todavía no tienes ningún referido",
      "emptyRewards": "Todavía no tienes ninguna recompensa"
    },
    "multipleServiceSettings": {
      "title": "Reservas de múltiples servicios",
      "description": "Con esta opción, tus clientes pueden seleccionar varios servicios en la misma reserva.",
      "activate": "Activar",
      "deactivate": "Desactivar",
      "config": "Configurar reglas",
      "configDesc": "Defina una o más reglas para reservas de múltiples servicios"
    },
    "posSettings": {
      "title": "Módulo Moloni",
      "discontinued": "Descontinuado",
      "description": "Emita sus facturas directamente desde BUK con su cuenta Moloni Flex o Pro. Incluye 2 meses gratis en Moloni exclusivo para clientes BUK.",
      "link": "Saber más",
      "activate": "Configurar",
      "deactivate": "Desactivar"
    },
    "salesSettings": {
      "title": "Registro de Ventas",
      "description": "Controla el dinero que entra y sale todos los días con el registro de ventas.",
      "cta": "Configurar"
    },
    "invoicingSettings": {
      "title": "BUK Facturación",
      "description": "Emita facturas y gestione su contabilidad directamente en BUK con nuestro módulo de facturación.",
      "cta": "Configurar"
    },
    "salesSetupPage": {
      "title": "Registro de Ventas",
      "active": "Activo",
      "inactive": "Inactivo",
      "desc": "Controle el dinero que entra y sale todos los días con el módulo de registro de ventas.",
      "activate": "Activar",
      "deactivate": "Desactivar",
      "help": "Ayuda",
      "boxTitle": "¿Qué está incluido?",
      "li1": "Menú de gestión de ventas",
      "li2": "Registro de pagos y descuentos",
      "li3": "Registro de deudas de clientes",
      "li4": "Registro de comisiones",
      "cancelTitle": "Atención",
      "cancelDescription": "Al desactivar el módulo de ventas perderá acceso a funcionalidades que pueden ser críticas para su negocio, como Gestión de pagos, Estadísticas de Ventas y Comisiones.",
      "continue": "Continuar",
      "tutorialTitle0": "Módulo de Ventas activado!",
      "tutorialDescription0": "Ahora puede gestionar sus ventas dentro de BUK, haga clic en continuar para saber más.",
      "tutorialTitle1": "Menú de Gestión de Ventas",
      "tutorialDescription1": "Acceda al nuevo menú de Ventas a través de la navegación principal, aquí puede ver todos los registros de ventas, pagos y comisiones.",
      "tutorialTitle2": "Registro de ventas",
      "tutorialDescription2": "Registre sus ventas en segundos, con un proceso simple e intuitivo. Agregue descuentos y elija uno o más métodos de pago.",
      "tutorialTitle3": "Comisiones",
      "tutorialDescription3": "Configure las comisiones de sus colaboradores y consulte los informes en el menú de Ventas.",
      "tutorialTitle4": "Módulo de Facturación BUK",
      "tutorialDescription4": "Ahora también puede emitir facturas directamente en BUK con nuestro módulo de facturación integrado.",
      "managePermissions": "Permisos",
      "permissionsModal": {
        "title": "Permisos de ventas",
        "subtitle": "Defina quién puede ver, editar o eliminar datos de ventas en esta tienda.",
        "columnUser": "Usuario",
        "columnView": "Ver",
        "columnEdit": "Editar",
        "columnDelete": "Eliminar",
        "adminFootnote": "Los administradores siempre tienen acceso completo a las ventas; las casillas para esas cuentas son solo informativas.",
        "save": "Guardar",
        "cancel": "Cancelar",
        "close": "Cerrar",
        "loading": "Cargando usuarios…",
        "loadError": "No se pudo cargar la lista de usuarios."
      },
      "invoiceActiveTitle": "Necesita el módulo de ventas activo para utilizar el módulo de facturación",
      "invoiceActiveDescription": "Para desactivar el módulo de ventas, primero debe desactivar el módulo de facturación.",
      "goToInvoicing": "Saber más sobre facturación"
    },
    "invoicingSetupPage": {
      "title": "BUK Facturación",
      "active": "Activo",
      "inactive": "Inactivo",
      "desc": "Emita facturas de forma automática y organizada, sin complicaciones. Tenga siempre el control de sus ventas y pagos en un solo lugar.",
      "askForAccess": "Pedir acceso",
      "certificate": "Certificado por la Autoridad Tributaria Nº2578."
    },
    "invoicingOnboardSetupPage": {
      "setupHeader": "Para acceder al módulo de facturación, necesitamos que nos envíe algunos datos",
      "merchantName": "Nombre de Registro",
      "vatNumber": "NIF de la entidad",
      "emailAddress": "Correo electrónico",
      "address": "Dirección",
      "city": "Localidad",
      "postalCode": "Código postal",
      "postalCodeInvalid": "El código postal debe tener el formato XXXX-XXX",
      "sendRequest": "Enviar solicitud",
      "askForHelp": "Hablar con nosotros"
    },
    "storeSettingsPage": {
      "businessName": "Nombre",
      "invalidBusinessName": "Por favor introduzca el nombre de su establecimiento.",
      "phone": "Móvil",
      "phonePlaceholder": "Número de Móvil",
      "invalidPhone": "Por favor introduce tu número de móvil",
      "addressPlaceholder": "Escribe tu dirección",
      "address": "Dirección",
      "invalidAddress": "Por favor introduce la dirección",
      "allowBookingsOnlyBefore": "No permitir a los clientes reservar dentro de:",
      "maxDaysInAdvance": "No permitir a los clientes reservar más allá de:",
      "allowBookingsOnlyBeforeEx": "Ej. Un cliente no podrá agendar un servicio para dentro de 30 minutos (si tienes configurada 1 hora)",
      "maxDaysInAdvanceEx": "Ej. Un cliente no podrá agendar un servicio para dentro de 13 meses (si tienes configurado 12 meses)",
      "calendarIntervals": "Intervalos de tiempo del calendario",
      "notificationAdvanceTime": "Antelación del recordatorio por correo electrónico y SMS",
      "notificationAdvanceTimeNoSMS": "Antelación del recordatorio por correo electrónico",
      "timezone": "Zona horaria:",
      "slug": "Enlace",
      "invalidSlug": "Por favor escriba cómo quieres tu enlace",
      "deleteStoreSure": "¿Estás seguro de que quieres eliminar \"{{insert}}\"? Atención: Esta acción no se puede deshacer.",
      "pageTitle": "Configuraciones generales",
      "basicStoreTitle": "Información básica",
      "basicStoreDesc": "Mantén la información de tu negocio actualizada",
      "configStoreTitle": "Agenda & Página de reservas",
      "configStoreDesc": "Configura y adapta tu agenda a la realidad de tu negocio",
      "notesOnEvents": "Mostrar observaciones en el calendario",
      "notesOnEventsNo": "No",
      "notesOnEventsYes": "Sí",
      "hideProvidersOutOfOffice": "Ocultar colaboradores fuera de la oficina",
      "hideProvidersOutOfOfficeNo": "No",
      "hideProvidersOutOfOfficeYes": "Sí",
      "customFieldsTitle": "Campos personalizados",
      "customFieldsDescription": "Añade campos personalizados a tu página de reservas y obtén información adicional de tus clientes",
      "customFieldsConfig": "Configurar",
      "customFieldsEmptyState": "No tienes campos personalizados.",
      "optimizeOnlineBookings": "Optimizar reservas online",
      "optimizeOnlineBookingsDescription": "Reduzca los huecos en su agenda y mejore la ocupación estableciendo los horarios que los clientes pueden reservar online",
      "minimizeHolesOnCalendarNo": "Intervalos regulares de tiempo",
      "minimizeHolesOnCalendarNoDescription": "Muestre todos los horarios disponibles según el intervalo definido. Esto puede crear huecos en su agenda",
      "minimizeHolesOnCalendarYes": "Reducir huecos en la agenda",
      "minimizeHolesOnCalendarYesDescription": "Muestre de forma inteligente más horarios disponibles a sus clientes, evitando huecos difíciles de llenar en la agenda"
    },
    "storeMessagingPage": {
      "pageDisclaimer": "Estos son los mensajes que se envían automáticamente a tus clientes cuando crean una cita, la editan, cancelan y en la víspera.",
      "guidanceTitleConfirm": "Cita Confirmada",
      "confirmEmail": "Hola <strong>%NOMBRE%</strong>, <br/>Tu cita para <strong>%NOMBRE_NEGOCIO%</strong> ha sido confirmada.<br/>Fecha de la cita: <strong>%SERVICE%</strong><br/>Fecha: <strong>%FECHA%</strong><br/><br/>{{insert}} Recurso: <strong>%MIEMBRO_DEL_EQUIPO%</strong><br/><br/>Si deseas cancelar esta cita, simplemente haz clic en el siguiente enlace <strong>%CANCELACIÓN_LINK%</strong> o llámanos al <strong>%TELÉFONO%</strong><br/><br/>Gracias",
      "guidanceTitleEdited": "Tu cita ha sido cambiada",
      "editedEmail": "Hola <strong>%NOMBRE%</strong>,<br/>Tu cita (<strong>%NOMBRE_NEGOCIO%</strong>) ha sido cambiada a <strong>%FECHA%</strong>.<br/><br/>{{insert}} Si deseas cancelar esta cita, simplemente haz clic en el siguiente enlace <strong>%CANCELACIÓN_LINK%</strong> o llámanos al <strong>%TELÉFONO%</strong><br/><br/>Gracias",
      "guidanceTitleCanceled": "La cita ha sido cancelada",
      "canceledEmail": "Hola <strong>%NOMBRE%</strong>, <br/>Tu cita para <strong>%NOMBRE_NEGOCIO%</strong> <strong>%FECHA%</strong> ha sido cancelada.<br/><br/>{{insert}} Contáctanos al <strong>%TELÉFONO%</strong> para más información.<br/><br/>Gracias",
      "guidanceTitleReminder": "Recordatorio de Cita",
      "reminderEmail": "Hola <strong>%NOMBRE%</strong>,<br/> Este es solo un recordatorio de que tienes una cita <strong>%FECHA%</strong> con <strong>%NOMBRE_NEGOCIO%</strong><br/><br/>{{insert}} Si deseas cancelar esta cita, simplemente haz clic en el siguiente enlace <strong>%CANCELACIÓN_LINK%</strong> o llámanos al <strong>%TELÉFONO%</strong><br/><br/>Gracias",
      "emailTitle": "Correo electrónico",
      "smsTitle": "Mensajes de texto",
      "smsGuidance": "Debes estar en un plan de pago para que tus clientes reciban mensajes de texto",
      "editedSMS": "Tu cita ha sido cambiada a %FECHA% %NOMBRE_NEGOCIO%. Si deseas cancelar, sigue este enlace %CANCELACIÓN_LINK% o llama a %TELÉFONO%",
      "canceledSMS": "Tu cita para %FECHA% %NOMBRE_NEGOCIO% ha sido cancelada. Contáctanos al %TELÉFONO% para más información.",
      "reminderSMS": "Este es solo un recordatorio de que tienes una cita %FECHA% (%NOMBRE_NEGOCIO% - %TELÉFONO%)",
      "importantInformation": "Información importante:",
      "importantInformationHelper": "Opcionalmente puedes agregar información adicional en el correo electrónico:",
      "guidanceSenderSMS": "De ",
      "invalidChangeBookingSMS": "Campo obligatorio: introduce un mensaje para la Cita Modificada (máx: 160 caracteres)",
      "invalidCanceledBookingSMS": "Campo obligatorio: introduce un mensaje para la Cita Cancelada (máx: 160 caracteres)",
      "invalidReminderSMS": "Campo obligatorio: introduce un mensaje para el Recordatorio de Cita (máx: 160 caracteres)",
      "resetText": "Restablecer al texto original",
      "invalidSenderSMS": "Campo obligatorio: introduce el Nombre del Remitente (máx: 11 caracteres)",
      "senderStatusApproved": "Aprobado",
      "senderStatusPending": "Pendiente de aprobación",
      "senderStatusRejected": "Rechazado",
      "senderStatusFallbackNote": "Mientras este remitente no esté aprobado, los SMS se enviarán con el remitente \"BUK\".",
      "senderStatusRejectedNote": "Este nombre de remitente fue rechazado. Intente con un nuevo nombre. Mientras tanto, los SMS se enviarán con el remitente \"BUK\".",
      "customSmsTitle1": "Personaliza tus recordatorios por mensaje de texto",
      "customSmsTitle2": "Usa los campos especiales a continuación para personalizar tu mensaje",
      "fieldsDate": "para la fecha de la cita en formato relativo (ex: Jueves, 1 de Enero 09:30)",
      "fieldsDateFull": "para la fecha de la cita en formato completo (ex: 01/01/2026 09:30)",
      "fieldsStoreName": "para el nombre de la tienda",
      "fieldsStoreContact": "para el contacto de la tienda",
      "fieldsProviderName": "para el nombre del miembro del personal",
      "fieldsServiceName": "para el nombre del servicio",
      "fieldsCancelLink": "para el enlace de cancelación de la cita",
      "fieldClientName": "para el nombre del cliente",
      "dateField": "%FECHA%",
      "dateFullField": "%FECHA_NUM%",
      "storeNameField": "%NOMBRE_NEGOCIO%",
      "clientNameField": "%NOMBRE_CLIENTE%",
      "providerNameField": "%MIEMBRO_DEL_EQUIPO%",
      "serviceNameField": "%SERVICIO%",
      "phoneField": "%TELÉFONO%",
      "cancelLinkField": "%CANCELACIÓN_LINK%",
      "birthdaySMS": "Recordatorio de Cumpleaños por Texto",
      "birthdaySmsSetting": "Enviar Recordatorio por Texto en los Cumpleaños de los Clientes",
      "birthdayMessage": "En este día especial te deseamos un gran cumpleaños de parte de todo el equipo de %NOMBRE_NEGOCIO%",
      "invalidClientBirthdayMessage": "Campo obligatorio: introduce un mensaje para el Recordatorio de Cumpleaños por Texto (máx: 160 caracteres)",
      "senderStatusUnsaved": "Para enviar tu remitente, haz clic en \"Guardar\" al final de la página.",
      "nameInstructions": "Lee nuestros consejos para elegir un nombre de remitente",
      "namingInstructionsTitle": "Remitente SMS",
      "namingInstructionsDescription": "En algunos casos, los operadores de telecomunicaciones, como MEO, Vodafone, NOS, entre otros, así como los propios dispositivos móviles, pueden clasificar automáticamente algunos mensajes como spam.<br/><br/>Desafortunadamente, este filtrado lo realizan los operadores o los sistemas de los propios dispositivos, por lo que no tenemos control directo sobre esta decisión.<br/><br/>Hemos observado que, tanto en Portugal como en otros países, los operadores han estado haciendo los filtros de SMS más estrictos, con el objetivo de reducir el aumento de spam y mensajes fraudulentos.<br/><br/>Cuando el remitente del SMS es un nombre personal o demasiado genérico, en lugar del nombre del negocio, existe una mayor probabilidad de que el mensaje sea filtrado o marcado como spam.<br/><br/>Si tienes problemas con la entrega de SMS, recomendamos cambiar el nombre del remitente a algo más identificable y asociado al negocio. Alternativamente, también puedes probar usar \"BUK\" como remitente."
    },
    "calendarPage": {
      "today": "Hoy",
      "block": "Bloquear Horario",
      "book": "Nueva Cita",
      "newInvoice": "Nueva Factura",
      "teyaSoloPay": "Pago en terminal",
      "week": "Semana",
      "threeDay": "Tres días",
      "blocked": "Bloqueado",
      "day": "Día",
      "providerSelected": "Preferencia por colaborador",
      "invoiceExists": "Factura emitida",
      "paid": "Pagado online",
      "noCalendars": "Día sin agendas activas",
      "isLoyaltyPrizeBooking": "Premio de Fidelización",
      "defaultName": "Ejemplo",
      "add": "Añadir",
      "providers": "Equipo",
      "roomEquipment": "Sala / Equipo",
      "roomEquipmentShort": "Sala/Equip.",
      "roomOccupied": "OCUPADO",
      "busy": "Ocupado"
    },
    "storeSettingsMenu": {
      "services": "Servicios",
      "products": "Productos",
      "providers": "Equipo",
      "workplan": "Horarios",
      "notifications": "Notificaciones",
      "users": "Usuarios",
      "rooms": "Salas"
    },
    "workplanOverride": {
      "title": "Horarios para días especiales",
      "description": "Configura horarios para días especiales.",
      "upcomingExceptions": "Próximos horarios",
      "newException": "Nuevo horario",
      "noExceptions": "Aún no tienes horarios configurados.",
      "collaboratorsText": "colaborador(es)",
      "chooseDay": "Elige un día",
      "invalidDate": "Por favor selecciona una fecha válida",
      "dateRequired": "Por favor selecciona una fecha",
      "timeSlots": "Horarios",
      "chooseProviders": "Elige los colaboradores",
      "atLeastOneProviderRequired": "Por favor selecciona al menos un colaborador"
    },
    "clientSettingsMenu": {
      "clients": "Clientes",
      "blacklist": "Bloqueados"
    },
    "selectProvider": {
      "generalView": "Visión General",
      "newResource": "Nuevo Colaborador"
    },
    "newClientForm": {
      "addClient": "Agregar Cliente",
      "name": "Nombre",
      "namePlaceholder": "Nombre y apellidos",
      "invalidName": "Por favor, indica el nombre del cliente",
      "email": "Correo electrónico",
      "emailPlaceholder": "Correo electrónico",
      "invalidEmail": "Por favor, indica el correo electrónico del cliente",
      "vatNumber": "NIF",
      "vatNumberPlaceholder": "NIF",
      "invalidvatNumber": "Por favor indique el NIF del cliente",
      "phone": "Teléfono",
      "invalidNumber": "Número inválido",
      "notifyClient": "Enviar correo electrónico con el enlace a su Página de Reservas",
      "notes": "Observaciones",
      "notesPlaceholder": "Observaciones",
      "notifications": "Campañas de correo electrónico y SMS",
      "subscribed": "Acepta recibir",
      "unsubscribed": "No acepta recibir"
    },
    "newClientBlacklistForm": {
      "addClient": "Bloquear Cliente",
      "name": "Nombre",
      "namePlaceholder": "Nombre y apellidos",
      "invalidName": "Por favor indique su nombre",
      "email": "Correo electrónico",
      "emailPlaceholder": "Correo electrónico",
      "invalidEmail": "Por favor indique tu correo electrónico",
      "phone": "Teléfono",
      "invalidNumber": "Número inválido"
    },
    "clientsPage": {
      "search": "Buscar nombre, correo o número",
      "create": "Nuevo",
      "newClient": "Nuevo cliente",
      "emptyStateH3": "Aún no tienes clientes en el sistema",
      "emptyStateP": "Añade clientes o comparte tu Página de Reservas y comienza a recibir a tus primeros clientes.",
      "emptyStateH3Blacklist": "Aún no tienes clientes bloqueados",
      "contactImportTitle": "Importa tu lista de clientes",
      "contactImport": "Para importar tu lista de clientes, contáctanos en: ",
      "tableHeaders": {
        "name": "Nombre",
        "email": "Correo electrónico",
        "phoneNumber": "Teléfono",
        "bookings": "Reservas",
        "lastVisit": "Última visita"
      },
      "filters": {
        "name": "Nombre Az",
        "bookingsAsc": "Más reservas",
        "bookingsDesc": "Menos reservas",
        "lastVisitAsc": "Visitas recientes",
        "lastVisitDesc": "Visitas antiguas"
      },
      "newCampaign": "Enviar campaña",
      "inactiveClientsTitle": "¡Llama de vuelta a tus clientes inactivos!",
      "inactiveClientsDesc": "Ofrece un descuento y promociona tus servicios con una campaña de SMS",
      "activeClientsTitle": "Comunícate con tus clientes",
      "activeClientsDesc": "Envía una campaña de SMS a través de nuestro sistema de Marketing",
      "noContacts": "Ningún contacto añadido",
      "importingDescription": "Estamos importando a sus clientes, este proceso puede tardar hasta 24 horas",
      "importButton": "Importar",
      "exportButton": "Exportar",
      "importExportButton": "Importar / Exportar"
    },
    "importClients": {
      "title": "Importar clientes",
      "subtitle": "Sube tu lista de clientes",
      "importButton": "Importar",
      "uploadFile": "Subir archivo",
      "uploadFileDescription": "Formatos: .xls, .csv o .vcf",
      "importExportTitle": "Importar / Exportar Clientes",
      "importExportSubtitle": "Importa nuevos clientes o exporta tu lista de clientes existente",
      "importMode": "Importar",
      "exportMode": "Exportar",
      "exportTitle": "Exportar Clientes",
      "exportDescription": "Exportar {{count}} clientes en formato Excel",
      "exportButton": "Exportar",
      "exportNoClients": "No tienes clientes para exportar",
      "csvExport": {
        "name": "Nombre",
        "email": "Correo electrónico",
        "phoneNumber": "Número de teléfono",
        "notes": "Observaciones",
        "subscribed": "Acepta comunicaciones de marketing?",
        "vatNumber": "NIF",
        "bookings": "Número de Reservas",
        "lastVisit": "Última Visita"
      }
    },
    "clientForm": {
      "personalInfo": "Información Personal",
      "general": "Visión General",
      "name": "Nombre",
      "namePlaceholder": "Nombre y apellidos",
      "nameInvalid": "Por favor, indica el nombre del cliente",
      "email": "Correo electrónico",
      "emailPlaceholder": "Correo electrónico",
      "emailInvalid": "Por favor, indica el correo electrónico del cliente",
      "vatNumber": "NIF",
      "vatNumberPlaceholder": "NIF",
      "vatNumberInvalid": "Por favor indica el NIF del cliente",
      "phone": "Teléfono",
      "phoneInvalid": "Número inválido",
      "deleteClient": "Eliminar Cliente",
      "bookings": "Reservas",
      "emptyBookings": "Este cliente no tiene reservas...",
      "addToBlacklist": "Bloquear",
      "removeFromBlacklist": "Desbloquear",
      "notes": "Observaciones",
      "notesPlaceholder": "Observaciones",
      "subscribed": "El cliente desea recibir campañas por correo electrónico y SMS",
      "dob": "Fecha de nacimiento",
      "stats": "Estadísticas",
      "history": "Historial",
      "seeMore": "Ver más ▾",
      "loadMore": "Cargar más",
      "nextBookings": "Próximas reservas",
      "complete": "Completas",
      "canceled": "Canceladas",
      "noshow": "Ausencias",
      "totalValue": "Valor total",
      "lastVisitHeader": "Última visita el",
      "activeClient": "Cliente activo",
      "inactiveClient": "Cliente inactivo",
      "newClient": "Cliente nuevo",
      "options": "Opciones",
      "editClient": "Editar",
      "canceledBy": "Cancelada por",
      "createdBy": "Creado por",
      "client": "cliente",
      "canceledByCustomer": "Cancelada por el cliente",
      "source": "Origen",
      "gender": "Género",
      "customFields": "Campos personalizados",
      "whatsapp": "Enviar WhatsApp",
      "sales": "Ventas",
      "files": "Archivos"
    },
    "clientAttachments": {
      "upload": "Elegir archivos",
      "drag": "Subir archivo",
      "fileTypeSize": "PDF, JPG, PNG, DOCX, etc (Máx. {{max}}MB)",
      "noAttachments": "No hay archivos adjuntos.",
      "document": "Documento",
      "fileTooLarge": "Archivo demasiado grande. El tamaño máximo es {{max}}MB."
    },
    "documentPreviewModal": {
      "cannotPreview": "No se puede previsualizar este tipo de archivo",
      "downloadToView": "Descárgalo para visualizarlo",
      "download": "Descargar",
      "downloadAttachment": "Descargar",
      "deleteAttachment": "Eliminar",
      "deleteAttachmentTitle": "¿Seguro que quieres eliminar este archivo?"
    },
    "statsPage": {},
    "userForm": {
      "createUser": "Crear nuevo usuario",
      "editUser": "Editar usuario",
      "name": "Nombre",
      "namePlaceholder": "Nombre",
      "invalidName": "Nombre inválido",
      "email": "Correo electrónico",
      "emailPlaceholder": "Correo electrónico",
      "invalidEmail": "Correo electrónico inválido",
      "roleLabel": "Perfil de Acceso",
      "rolePlaceholder": "Selecciona un perfil",
      "roleInvalidMessage": "Perfil de acceso inválido",
      "createUserButton": "Crear usuario",
      "editUserButton": "Guardar",
      "deleteUser": "Eliminar",
      "resendInvitation": "Reenviar correo de invitación",
      "inviteLinkLabel": "Enlace para establecer la contraseña",
      "inviteLinkLoading": "Cargando enlace...",
      "instructions": "Se enviará una invitación a esta dirección de correo electrónico.",
      "salesPermissions": "Permisos de Ventas",
      "canCreateEditSales": "Puede crear y editar ventas",
      "canViewSales": "Puede ver ventas",
      "canDeleteSales": "Puede eliminar ventas"
    },
    "setupStoreUsers": {
      "guidanceTitle": "Gestiona los accesos",
      "activeUser": "Activo",
      "inactiveUser": "Inactivo",
      "addNew": "Añadir nuevo"
    },
    "stripeSettings": {
      "title": "Pagos Online (Stripe)",
      "description": "Tarjeta de crédito, Apple Pay, Google Pay.",
      "configure": "Configurar",
      "mandatoryPayments": "Activar pago obligatorio",
      "optionalPayments": "Desactivar pago obligatorio",
      "mandatoryPaymentsAreDeactived": "El pago no es obligatorio para realizar una reserva.",
      "mandatoryPaymentsAreActived": "El pago es obligatorio para realizar una reserva."
    },
    "paymentSettings": {
      "title": "BUK Pay",
      "description": "Permite el pago anticipado con tarjeta de crédito, Apple/Google Pay (Comisión 1,9 % + 0,50 €).",
      "configure": "Configurar"
    },
    "accountSettingsMenu": {
      "account": "Mi cuenta",
      "subscription": "Suscripción",
      "invoices": "Facturas",
      "invoicesText": "Tus facturas estarán disponibles al inicio del día siguiente"
    },
    "tutorialBanner": {
      "tip1": "Cómo realizar una reserva",
      "tip2": "Menús y funcionalidades de la agenda",
      "tip3": "Cómo personalizar tu página de reservas",
      "watchPlaylist": "Ver vídeos"
    },
    "embedCodeSetup": {
      "wordpress1": "Si tu sitio web está desarrollado en WordPress",
      "wordpress2": "consulta aquí nuestro plugin",
      "copyCode": "Copiar código",
      "copyCodeSuccess": "Código copiado"
    },
    "setupCustomFields": {
      "text": "Texto",
      "date": "Fecha",
      "dropdown": "Varias Opciones",
      "optional": "Opcional",
      "public": "Público",
      "private": "Privado",
      "addNew": "Añadir nuevo",
      "editCreateServices": "Editar campo personalizado",
      "name": "Nombre del campo",
      "invalidName": "Nombre inválido",
      "type": "Tipo de campo",
      "invalidType": "Tipo inválido",
      "showOnBookingPage": "Campo público",
      "showOnBookingPageDesc": "Visible en tu página de reservas",
      "mandatoryShort": "Obligatorio",
      "mandatory": "Campo obligatorio",
      "mandatoryDesc": "Para los clientes (reservas online)",
      "confirmDeleteField": "¿Está seguro de que desea eliminar este campo personalizado?",
      "dropdownValues": "Opciones (una opción por línea)",
      "invalidDropdownValues": "Opciones inválidas",
      "alertMsg1": "No añadas aquí los campos NIF, Fecha de Nacimiento y Género.",
      "alertMsg2": "Puedes añadirlos en \"Más opciones\" de tu página de reservas,",
      "alertMsg3": "haz clic aquí."
    },
    "marketingModal": {
      "no": "No, gracias",
      "usePromo": "Usar promoción"
    }
  },
  "GENERAL": {
    "here": "aquí",
    "invalidValue": "Valor inválido",
    "downloading": "Descargando...",
    "download": "Descargar",
    "filters": "Filtros",
    "all": "Todos",
    "salesExport": "ventas",
    "pay": "Pagar",
    "paid": "Pagado",
    "invoice": "Factura",
    "receipt": "Recibo",
    "creditNote": "Nota de crédito",
    "step": "Paso",
    "of": "de",
    "options": "Opciones",
    "date": "Fecha",
    "state": "Estado",
    "generalErrorMsg": "Algo salió mal. Por favor, intente de nuevo.",
    "chooseOption": "Elije una opción",
    "error": "Algo salió mal. Por favor, intente de nuevo.",
    "retry": "Reintentar",
    "email": "Correo electrónico",
    "phone": "Teléfono",
    "invalidEmail": "Correo electrónico inválido",
    "password": "Contraseña",
    "continue": "Continuar",
    "requiredField": "Campo obligatorio",
    "with": "con",
    "total": "Total",
    "signupCta": "¡Registrate Gratis!",
    "services": "Servicios",
    "schedule": "Horarios",
    "resource": "Colaborador",
    "resources": "Colaboradores",
    "price": "Precio",
    "remove": "Eliminar",
    "upload": "Upload",
    "save": "Guardar",
    "saveDraft": "Guardar borrador",
    "updateDraft": "Actualizar borrador",
    "cancel": "Cancelar",
    "configure": "Configurar",
    "savedSuccessfully": "¡Guardado con éxito!",
    "deletedSuccessfully": "¡Eliminado con éxito!",
    "changesNotSaved": "Los cambios no fueron guardados.",
    "edit": "Editar",
    "editServices": "Editar servicios",
    "fileTypeNotSupported": "Archivo no soportado",
    "storeTypes": {
      "agenda": "Agenda",
      "store": "Tienda",
      "salon": "Salón",
      "center": "Centro",
      "clinic": "Clínica",
      "office": "Oficina",
      "agency": "Agencia",
      "local": "Local"
    },
    "merchantTypes": {
      "optical": "Centro Óptico",
      "psychology": "Psicología",
      "nutricionist": "Nutricionista",
      "hairsalon": "Peluquería",
      "barber": "Barbero",
      "beautySalon": "Salón de Belleza",
      "spaMassages": "Spa/Masajes",
      "personalTrainer": "Entrenador Personal",
      "physiotherapy": "Fisioterapia",
      "dentist": "Clínica/Dentista",
      "veterinarian": "Clínica Veterinaria",
      "petService": "Cuidado de animales",
      "photography": "Fotografía",
      "realEstate": "Inmobiliaria",
      "consultancy": "Consultoría",
      "advocacy": "Bufete de abogados",
      "tutorMentor": "Tutor/Mentor",
      "sports": "Deporte",
      "other": "Otro",
      "nailsArtists": "Uñas",
      "makeupArtists": "Maquillaje",
      "lashesArtists": "Pestañas",
      "osteopath": "Osteopatía",
      "clinic": "Clínica",
      "aesthetic": "Estética",
      "holisticTeraphy": "Terapias holísticas",
      "tattooArtists": "Tatuajes",
      "pharmacy": "Farmacia",
      "fitness": "Fitness",
      "auto": "Automóviles"
    },
    "new": "Nuevo",
    "no": "No",
    "yes": "Sí",
    "month": "mes",
    "months": "meses",
    "week": "semana",
    "weeks": "semanas",
    "year": "año",
    "areYouSure": "¿Está seguro?",
    "cookieConsent": "Este sitio utiliza cookies para mejorar la experiencia del usuario y analizar el tráfico del sitio web. Por estas razones, podemos compartir sus datos de uso con nuestros socios analíticos y de redes sociales. Al hacer clic en \"Aceptar Cookies\", autoriza el almacenamiento en su dispositivo de las tecnologías descritas en nuestra",
    "cookieConsentBtn": "Aceptar Cookies",
    "back": "Volver",
    "close": "Cerrar",
    "gender": {
      "male": "Masculino",
      "female": "Femenino",
      "other": "Otro"
    },
    "validators": {
      "invalidPortugueseVat": "NIPC/NIF no válido para Portugal (para números internacionales, use el código del país, ej.: FR12345678901)",
      "invalidSpanishVat": "NIF no válido para España (para números internacionales, use el código del país, ej.: FR12345678901)"
    },
    "advancedOptions": "Opciones avanzadas",
    "walkInCustomer": "Consumidor final"
  },
  "MARKETING": {
    "newCampaign": "Nueva Campaña",
    "campaigns": "Campañas",
    "processing": "Procesando",
    "sent": "Enviado",
    "client": "cliente",
    "clients": "clientes",
    "content": "Contenido",
    "editContent": "Editar contenido",
    "pageTitleSms": "Campaña SMS",
    "campaignType": "Tipo de campaña",
    "pageTitleEmail": "Campaña de correo electrónico",
    "storesPlaceholder": "Todas las Tiendas",
    "titleLabel": "Nombre de la Campaña",
    "titlePlaceholder": "Nombre de la Campaña",
    "titleError": "Nombre inválido",
    "fromEmail": "De",
    "fromEmailPlaceholder": "Nombre del remitente",
    "fromEmailError": "Remitente inválido",
    "subjectLabel": "Asunto",
    "subjectPlaceholder": "Asunto del mensaje",
    "subjectError": "Asunto inválido",
    "senderLabel": "De",
    "senderPlaceholder": "De",
    "senderError": "Remitente inválido. Debe contener un máximo de 11 caracteres sin espacios, números ni símbolos.",
    "templateTitle": "Título",
    "templateText": "Texto",
    "templateShowCover": "Mostrar imagen de cabecera",
    "templateShowCTA": "Mostrar botón CTA",
    "templateCtaText": "Texto del botón",
    "templateCtaLink": "Enlace del botón",
    "templateLabel": "Mensaje",
    "templatePlaceholder": "Escriba el contenido de su mensaje",
    "templateError": "Mensaje inválido",
    "characters": "Caracteres",
    "test": "Enviar Prueba",
    "sendCampaign": "Enviar campaña",
    "send": "Enviar",
    "presets": {
      "allTitle": "Todos los clientes",
      "allSubTitle": "Toda la lista de clientes",
      "activeTitle": "Clientes activos",
      "activeSubTitle": "Clientes con citas en los últimos {{months}} meses",
      "activeSubTitle2": "Clientes con citas",
      "activeSubTitle3": "Clientes con citas en los últimos",
      "newTitle": "Nuevos clientes",
      "newSubTitle": "Clientes que realizaron su primera cita en los últimos 30 días",
      "oldTitle": "Clientes inactivos",
      "oldSubTitle": "Clientes sin citas en los últimos {{months}} meses",
      "oldSubTitle2": "Clientes sin citas",
      "oldSubTitle3": "Clientes sin citas en los últimos"
    },
    "testSent": "Prueba enviada con éxito",
    "exclude": "Excluir",
    "excludeContact": "Excluir contacto",
    "excludeContactConfirm1": "Desea excluir",
    "excludeContactConfirm2": "solo de esta campaña o también de futuras comunicaciones?",
    "excludeContactBtnThis": "Solo de esta campaña",
    "excludeContactBtnAll": "De esta campaña y futuras",
    "contactImport": "¿Quieres importar tu lista de clientes?? <br/> Envíanos un correo a ",
    "sendDate": "Fecha de envío",
    "campaignCost": "Coste de la campaña",
    "errorNoClients": "Debe elegir un grupo de clientes primero",
    "marketingConsentInfo": "Solo se muestran en esta lista los clientes que han aceptado recibir comunicaciones de marketing.",
    "defaultSubject": "Asunto del correo",
    "defaultTitle": "Título de la campaña",
    "defaultCtaCopy": "Reserve ahora",
    "defaultText": "Texto de tu campaña...",
    "defaultSms": "Tu mensaje...",
    "tableCampaign": "Campaña",
    "tableSent": "Enviados",
    "tableDate": "Fecha de Envío",
    "tableROI": "Retorno",
    "tableBookings": "reservas",
    "tableBooking": "reserva",
    "tableCost": "Coste",
    "tableStatus": "Estado",
    "subtitle": "Envía novedades o promociones a todos tus clientes",
    "balanceBanner": "Aproveche {{balance}}€ de descuento en su próxima campaña",
    "senderStatusApproved": "Aprobado",
    "senderStatusPending": "Pendiente de aprobación",
    "senderStatusRejected": "Rechazado",
    "senderStatusFallbackNote": "Mientras no esté aprobado, los SMS se enviarán con el remitente \"BUK\". Puedes cambiarlo en",
    "senderStatusApprovedNote": "Puedes cambiarlo en",
    "senderStatusRejectedNote": "Este nombre de remitente fue rechazado. Intente con un nuevo nombre. Mientras tanto, los SMS se enviarán con el remitente \"BUK\". Puedes cambiarlo en",
    "senderStatusLink": "configuración de notificaciones",
    "senderFreePlanNote": "Actualiza al plan Pro para personalizar el remitente de tus SMS.",
    "senderFreePlanGeneric": "BUK",
    "chooseTemplate": "Elige una de nuestras plantillas",
    "newSuggestion": "Nueva sugerencia",
    "confirmModal": {
      "title": "Enviar campaña",
      "clients": "Clientes",
      "price": "Precio",
      "priceMin": "Precio mínimo de envío",
      "priceCredit": "¡Crédito de {{balance}}€ aplicado!",
      "choosePayment": "Elige un método de pago",
      "btnCard": "Tarjeta",
      "btnMbway": "MBWay",
      "btnMbwayMsg": "Recibirás una notificación en la app MBWay para realizar el pago de ",
      "changeCard": "Cambiar tarjeta",
      "useSelectedCard": "Usar tarjeta predeterminada",
      "stateMbwayTitle": "Valide el pago en MBWay",
      "stateMbwayText": "Pedido enviado a:",
      "stateSendingTitle": "Preparando el envío...",
      "stateSendingText": "Espera un momento, por favor",
      "stateSuccessTitle": "¡Campaña enviada!",
      "stateSuccessText": "Tus clientes recibirán tu campaña en los próximos minutos.",
      "stateSuccessBtn": "Volver al marketing",
      "cancel": "Cancelar",
      "sendNow": "Enviar ahora"
    }
  },
  "CONFIRM_DRAG": {
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "change_booking": "Cambiar reserva",
    "change_holiday": "Cambiar bloqueo",
    "before": "Anteriormente",
    "now": "Ahora",
    "notify_client": "Notificar al cliente"
  },
  "ACCOUNT": {
    "hi": "Hola",
    "basic_info": "Información básica",
    "first_last_name": "Nombre y apellido",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "current_password": "Contraseña actual",
    "new_password": "Nueva contraseña",
    "account_notifications": "Notificaciones de la cuenta",
    "new_booking": "Correo de nueva reserva",
    "new_booking_desc": "Siempre que tengas una nueva reserva",
    "notify_only_provider": "Recibir notificaciones de:",
    "notify_only_provider_desc": "Recibir emails y notificaciones solo de las reservas de este colaborador",
    "notify_all_providers": "Todos los colaboradores",
    "payment_confirmation": "Correo de pago confirmado",
    "payment_confirmation_desc": "Cuando un cliente completa el pago de una reserva creada desde el backoffice",
    "push_new_booking": "Notificación de nueva reserva",
    "push_new_booking_desc": "Siempre que tengas una nueva reserva",
    "canceled_booking": "Correo de reserva cancelada",
    "canceled_booking_desc": "Siempre que un cliente cancele una reserva",
    "push_canceled_booking": "Notificación de reserva cancelada",
    "push_canceled_booking_desc": "Siempre que un cliente cancele una reserva",
    "otherOptions": "Otras opciones",
    "language": "Elige tu idioma"
  },
  "SUBSCRIPTION": {
    "subscriptionTitle": "Tu suscripción",
    "next_payment": "Próximo pago",
    "providers": "colaborador(es)",
    "discount": "Descuento",
    "total": "Total",
    "card": "Tarjeta",
    "direct_debit": "Domiciliación Bancaria",
    "payment_method": "Método de Pago",
    "edit": "Editar suscripción",
    "invoices": "Ver facturas",
    "without_sms": "Sin SMS",
    "proPlan": "Plan Pro",
    "proPlusPlan": "Plan Pro+",
    "plansVAT": "IVA incluido al tipo vigente"
  },
  "INVOICES": {
    "desc": "Tus facturas estarán disponibles al inicio del día siguiente",
    "invoice_data": "Datos de facturación",
    "company_name": "Nombre (opcional)",
    "company_vat": "Número de identificación fiscal",
    "name": "Nombre",
    "date": "Fecha",
    "value": "Valor",
    "emptyState": "No hay facturas disponibles"
  },
  "SIGNUP": {
    "testimonial": {
      "benefitsTitle": "¿Por qué usar BUK?",
      "benefitsList": [
        "Gestión de Equipo y Clientes",
        "Recordatorios SMS ilimitados",
        "Envío de campañas de correo electrónico y SMS",
        "Página de reservas personalizada",
        "Posiciónate en Google Reviews",
        "Acepta pagos con tarjeta de crédito"
      ],
      "quote": "\"BUK es fácil de usar, super interactivo, práctico y funcional, permite trabajar de manera más organizada y profesional.\"",
      "author": "David Frazão — Bento Barbearías"
    }
  },
  "SETUP_GUIDE": {
    "create_account": "Crear cuenta",
    "configure_business": "Configura tu negocio",
    "add_your_schedule": "Añade tu horario",
    "add_your_services": "Añade tus servicios",
    "create_first_appointment": "Crea la primera reserva",
    "setup_booking_page": "Editar página de reservas",
    "import_clients": "Importe sus clientes",
    "win_10_eur": "Gane 10€",
    "stepsLeft": "Solo quedan {{steps}} pasos",
    "stepLeft": "Solo queda {{steps}} paso",
    "extraReady": "Prepárate al máximo ⚡️",
    "almostReady": "¡Está casi listo!",
    "noThankYou": "No, gracias",
    "extraStepLeft": "Solo queda {{steps}} paso extra ⚡️",
    "extraStepsLeft": "Solo quedan {{steps}} pasos extra ⚡️",
    "titleSuccess": "Bien, ¡has llegado al 100 %! 🎉",
    "descSuccess": "Ahora que tienes las configuraciones básicas, es hora de personalizar tu página de reservas.",
    "ctaSuccess": "Personalizar ahora"
  },
  "NPS": {
    "question": "En una escala del 0 al 10, ¿cuánto recomendarías BUK a un amigo o colega?",
    "subtitle": "0 - Poco probable / 10 - Muy probable",
    "thanks": "¡Gracias por tu opinión!",
    "btn1": "Cerrar",
    "btn2": "¡Calificar ahora!",
    "inviteModalTitle": "Invita amigos a BUK",
    "inviteModalSubtitle": "Ofrece un 50% de descuento a tus amigos y gana 50€ en créditos de Marketing y 50€ de crédito en tu suscripción.",
    "reviewBukOnGoogle": "¡Déjanos una reseña en Google y ayuda a otras personas a encontrarnos!",
    "inviteYourFriends": "Invita a tus amigos y gana 100€",
    "btnRef": "Invitar a amigos"
  },
  "CANCEL_XP": {
    "title": "Cancelar Suscripción",
    "warning": "Atención, perderás acceso a tu cuenta y a los datos de tus clientes.",
    "warning_account": "No podrás acceder a tu cuenta",
    "warning_clients": "No podrás acceder a los datos de tus clientes",
    "keep_access": "Para mantener el acceso a tu cuenta, debes cambiar al plan Gratis en 'Editar Suscripción'",
    "back": "Volver",
    "continue": "Continuar",
    "subtitle": "Elige una opción",
    "subtitle_improvements": "Ayúdanos a entender cómo podemos mejorar nuestro servicio",
    "subtitle_competitors": "¿Qué sistema vas a adoptar?",
    "subtitle_promo": "Queremos ofrecerte 3 meses con un 50% de descuento. ¿Estarías interesado?",
    "title_leaving": "Nos entristece verte partir...",
    "pricing_before": "ANTES",
    "pricing_now": "AHORA",
    "btn_accept": "Aceptar promoción",
    "btn_reject": "No aceptar y cancelar",
    "changeSoftware": "Cambié de software",
    "closing": "El negocio va a cerrar",
    "temporaryClose": "Voy a cerrar temporalmente",
    "personalReason": "Motivos personales",
    "notAdequate": "BUK no tiene lo que necesito",
    "other": "Otro",
    "price": "Mejor precio",
    "features": "Más funcionalidades",
    "support": "Mejor soporte técnico",
    "performance": "Menos bugs",
    "noSoftware": "Ninguno"
  },
  "GOOGLE_PLACE": {
    "input": " Procurar por nome ou morada"
  },
  "CREATE_MERCHANT": {
    "googleQuestion": "¿Tu negocio está en Google?",
    "googleNotes": "Solo usamos esta información para completar automáticamente detalles como horarios y servicios, ahorrándole tiempo al crear su cuenta.",
    "skipStep": "Saltar este paso",
    "confirm": "Confirmar"
  },
  "SALES_LIST_PAGE": {
    "sales": "Ventas",
    "payments": "Pagos",
    "commissions": "Comisiones",
    "filterFieldPlaceholder": "Filtrar por Nombre / NIF / Factura",
    "allUsers": "Todos",
    "state": "Estado",
    "paid": "Pagado",
    "cancelled": "Cancelado",
    "toPay": "Por pagar",
    "totalCommissions": "Comisiones",
    "totalAmountWithoutCommissions": "Total sin Comisiones",
    "emptyState": {
      "title": "Sin ventas",
      "description": "No hay ventas para mostrar."
    },
    "invoice": "Factura",
    "salesCode": "Venta",
    "nameVat": "Nombre / NIF",
    "registeredBy": "Registrado por",
    "totalValue": "Valor total",
    "downloadAll": "Descargar todas las facturas",
    "exportXLS": "Exportar (XLS)",
    "seeDetails": "Ver detalles",
    "emailInvoice": "Enviar factura",
    "downloadInvoice": "Descargar factura",
    "paymentMethod": "Método de pago",
    "paymentsCount": "Pago(s)",
    "continueDraft": "Continuar borrador",
    "deleteDraft": "Eliminar borrador",
    "deleteDraftConfirm": "¿Seguro que deseas eliminar este borrador? Esta acción no se puede deshacer."
  },
  "INVOICING_SERVICE": {
    "dateRanges": {
      "today": "Hoy",
      "yesterday": "Ayer",
      "thisWeek": "Esta semana",
      "lastWeek": "Semana pasada",
      "thisMonth": "Este Mes",
      "lastMonth": "Mes Pasado",
      "thisYear": "Este año",
      "firstQuarter": "1º Trimestre",
      "secondQuarter": "2º Trimestre",
      "thirdQuarter": "3º Trimestre",
      "fourthQuarter": "4º Trimestre",
      "untilNow": "Hasta ahora",
      "custom": "Personalizado",
      "nextWeek": "Próxima semana",
      "nextMonth": "Próximo mes",
      "fromNow": "A partir de ahora"
    }
  },
  "SALES_STATUS": {
    "paid": "Pago",
    "pending": "Por pagar",
    "cancelled": "Cancelado",
    "draft": "Borrador",
    "uninvoiced": "Por facturar"
  },
  "DATE_RANGE_MODAL": {
    "title": "Elige 2 fechas",
    "dateInit": "Fecha de inicio",
    "dateEnd": "Fecha de fin",
    "filter": "Filtrar",
    "dateFormat": "dd/mm/aaaa"
  },
  "PAYMENTS_LIST_PAGE": {
    "emptyState": {
      "title": "Sin pagos",
      "description": "No hay pagos para mostrar."
    },
    "invoice": "Factura",
    "nameVat": "Nombre / NIF",
    "registeredBy": "Registrado por",
    "paymentMethod": "Método de pago",
    "value": "Valor",
    "bukPay": "Stripe",
    "salesCode": "Venta",
    "paymentsOnline": "Online"
  },
  "INVOICE_PAYMENT_METHOD": {
    "title": "Facturar",
    "clientSection": "Datos de facturación",
    "vat": "NIF",
    "vatInvalid": "El NIF no es válido",
    "name": "Nombre",
    "cae": "CAE",
    "payLaterDescription": "Facturar ahora, pero recibir el pago más tarde",
    "partialPayDescription": "Facturar y recibir solo parte del valor de la venta",
    "fullPayDescription": "Facturar y recibir el valor total de la venta",
    "payLaterTitle": "Se registrará una venta pendiente de pago",
    "payLaterList1": "Se registrará una deuda en el cliente seleccionado",
    "payLaterList2": "Para liquidar esta deuda más tarde, puede consultar la ficha del cliente o la sección de Ventas",
    "payNow": "Valor a pagar ahora",
    "partialPaymentMissing": "Quedará registrado por pagar",
    "paymentMethod": "Método de pago",
    "paymentMethodRequired": "Elige al menos un método de pago",
    "valueByPaymentMethod": "Valor por método de pago",
    "value": "Valor",
    "paymentSumError": "La suma de los pagos debe ser igual al total a pagar",
    "descriptionLabel": "Observaciones",
    "descriptionPlaceholder": "Escribe observaciones adicionales",
    "descriptionError": "Observaciones inválidas, máximo 200 caracteres",
    "doInvoice": "Facturar",
    "doSale": "Registrar",
    "saveDraft": "Guardar borrador",
    "resumeDraftTitle": "Retomar borrador",
    "draftSavedBy": "guardado por {{name}} el {{date}}",
    "payment": "Pago",
    "card": "Tarjeta",
    "cash": "Efectivo",
    "mbway": "MB Way",
    "mbref": "Multibanco",
    "transfer": "Transferencia",
    "other": "Otro",
    "full": "Pagar todo",
    "partial": "Pagar parcial",
    "later": "Pagar después",
    "onlineApplePay": "Online (Apple Pay)",
    "onlineGooglePay": "Online (Google Pay)",
    "onlineCCard": "Online (Tarjeta de crédito)",
    "onlineMbway": "MB Way (BUK Pay)",
    "onlineMbref": "Online (Multibanco)",
    "teya": "Terminal Teya",
    "continueToTerminal": "Continuar al Terminal",
    "tabRegister": "Registrar",
    "tabRegisterHint": "Ya pagó",
    "tabMbWay": "MB Way",
    "tabMbWayHint": "Pedido",
    "tabBukPay": "BUK Pay",
    "tabBukPayHint": "Enlace",
    "tabTeya": "Teya",
    "tabTeyaHint": "Terminal",
    "phoneLabel": "Móvil",
    "emailLabel": "E-mail",
    "mbWayHelper": "Se enviará un pedido de pago MB Way a este número.",
    "bukPayHelper": "Se enviará un enlace de pago a este e-mail.",
    "emailPlaceholder": "Email del cliente",
    "methodNotActive": "Este método aún no está activo",
    "activateMbWay": "Activar MB Way",
    "activateMbWayHint": "Activa los pagos online para enviar pedidos MB Way.",
    "activateBukPay": "Activar BUK Pay",
    "activateBukPayHint": "Activa los pagos online para enviar enlaces BUK Pay.",
    "activateTeya": "Activar Teya",
    "activateTeyaHint": "Conecta el terminal Teya para cobrar en este dispositivo.",
    "sendMbWayRequest": "Enviar pedido MB Way",
    "sendBukPayLink": "Enviar enlace BUK Pay",
    "teyaTerminalHint": "Al continuar, el importe se envía al terminal Teya.",
    "linkSentToast": "Enlace de pago enviado",
    "mbwaySentToast": "Pedido MB Way enviado"
  },
  "COMMISSIONS_LIST_PAGE": {
    "totalCommission": "Comisión Total",
    "emptyState": {
      "title": "Ninguna comisión encontrada",
      "description": "No hay comisiones para mostrar en este momento."
    },
    "sale": "Venta",
    "nameVat": "Cliente",
    "serviceProduct": "Servicio",
    "totalWithVat": "Total c/IVA",
    "commissionWithVat": "Comisión c/IVA"
  },
  "INVOICE_PREVIEW": {
    "creditNote": "Cancelar (NC)",
    "cancelSale": "Cancelar",
    "pay": "Pagar",
    "summary": "Resumen",
    "discount": "Descuento Global",
    "subTotal": "Subtotal",
    "totalVAT": "IVA",
    "sendPaymentLink": "Enviar enlace de pago",
    "editPayments": "Editar pagos",
    "emptyState": "Añade un servicio o producto para empezar.",
    "seeDetails": "Ver detalles",
    "bookingDate": "Cita",
    "bookingOpenFailed": "No se pudo abrir esta cita. Puede haber sido eliminada o ya no aparece en el calendario.",
    "editSale": "Editar",
    "editingExistingSale": "No es posible editar elementos ya registrados. Para corregir algún error, por favor cancele esta venta.",
    "invoiceRemaining": "Facturar restante",
    "doInvoice": "Facturar",
    "cancelOldInvoiceWarning": "Al facturar, se emitirá una Nota de Crédito con el valor del depósito y una nueva factura con el valor total.",
    "atLeastOneItemMustHavePrice": "Para crear una venta con total cero, añade un importe y un descuento del 100%."
  },
  "INVOICING_PAGE": {
    "registerSale": "Registrar venta",
    "registerPayment": "Registrar pago"
  },
  "INVOICE_ADD_ITEMS": {
    "addPatientTitle": "Añadir cliente",
    "addPatientDescription": "Elija un cliente (opcional)",
    "title": "¿Qué desea registrar?",
    "searchPlaceholder": "Filtrar por nombre",
    "emptyServicesTitle": "Sin servicios",
    "emptyServicesDescription": "Sin servicios disponibles para mostrar.",
    "emptyProductsTitle": "Sin productos",
    "emptyProductsDescription": "Sin productos disponibles para mostrar.",
    "services": "Servicios",
    "products": "Productos"
  },
  "PATIENT_SELECTOR": {
    "patientName": "Nombre del cliente",
    "searchPlaceholder": "Buscar Nombre, NIF, Teléfono",
    "patientNotFound": "cliente no encontrado",
    "search": "Buscar",
    "createNewPatient": "Nuevo cliente"
  },
  "INVOICE_ITEM_EDIT_MODAL": {
    "title": "Editar",
    "quantity": "Cantidad",
    "unitPrice": "Precio",
    "discount": "Descuento",
    "vatRate": "IVA",
    "vatExemption": "Razón de exención de IVA",
    "hasProviders": "Asociar profesional",
    "provider": "Profesional",
    "lineDescription": "Descripción (para la factura)",
    "commission": "Comisión",
    "addProvider": "Agregar profesional"
  },
  "INVOICE_DISCOUNT_MODAL": {
    "discountPercentageInvalid": "Descuento inválido. Debe estar entre 0% y 100%.",
    "discountAmountCentsInvalid": "Cantidad de descuento inválida. Debe estar entre 0 y el total de la factura.",
    "title": "Descuento Global",
    "valueToPay": "Cantidad a pagar",
    "discount": "Descuento"
  },
  "SALE_DETAILS": {
    "headerTitle": "Venta",
    "registeredBy": "Registrado por",
    "documents": "Documentos",
    "history": "Historial",
    "missingPayment": "Falta de pago",
    "canceled": "Cancelado",
    "summary": "Resumen",
    "partialInvoice": "Prepago",
    "tip": "Propina"
  },
  "INVOICE_SUCCESS": {
    "success": "¡Venta registrada con éxito!",
    "conclude": "Concluir",
    "goToStart": "Ir al inicio",
    "goToSales": "Ir a ventas",
    "openSaleDetails": "Ver detalles de venta",
    "emailInvoice": "Enviar factura por correo",
    "printInvoice": "Imprimir factura",
    "downloadInvoice": "Descargar factura",
    "printTicket": "Imprimir ticket",
    "moreOptions": "Más opciones",
    "goToPayments": "Ir a pagos",
    "invoiceFailedTitle": "No se pudo generar la factura",
    "invoiceFailedDescription": "La venta se ha registrado pero la factura no se emitió. Para emitir la factura de esta venta, visite la página de Ventas.",
    "paymentFailedTitle": "Pago fallido",
    "paymentFailedDescription": "El pago no se completó. Puede volver a editar e intentarlo de nuevo.",
    "editAndRetry": "Editar e intentar de nuevo",
    "retryTeyaTerminal": "Enviar al terminal de nuevo"
  },
  "EDIT_COMMISSION_MODAL": {
    "title": "Editar comisión"
  },
  "CANCEL_INVOICE_MODAL": {
    "titleInvoice": "Emitir Nota de Crédito",
    "descriptionInvoice": "Atención, esta acción no podrá ser revertida. Se generará una nota de crédito con el valor total de la factura.",
    "title": "Cancelar",
    "description": "Atención, esta acción no podrá ser revertida.",
    "reasonLabel": "Motivo",
    "reasonPlaceholder": "Escriba un motivo",
    "cancel": "Cerrar",
    "paymentsWarning": "Debe realizar el reembolso personalmente.",
    "refundPaymentMethodLabel": "Método de reembolso",
    "refundPaymentMethodPlaceholder": "Seleccione el método de reembolso",
    "refundPaymentMethodRequired": "Seleccione el método de reembolso para continuar"
  },
  "REPLACE_INVOICE_MODAL": {
    "title": "Cancelar y corregir venta",
    "description": "Esta venta será cancelada y su contenido se copiará a una nueva.",
    "descriptionInvoice": "Atención: esta acción no podrá ser revertida.",
    "warningMessage": "Atención: esta venta tiene facturas asociadas. Se emitirá una Nota de Crédito automáticamente.",
    "descriptionNoInvoice": "Esta acción no podrá ser revertida.",
    "back": "Volver atrás",
    "cancelSale": "Cancelar venta",
    "cancelledSuccessfully": "¡Venta cancelada con éxito!"
  },
  "INVOICING_SETTINGS": {
    "setupHeader": "Para acceder al módulo de facturación, necesitamos que nos envíe algunos datos",
    "merchantName": "Nombre de registro",
    "vatNumber": "NIF de la entidad",
    "address": "Dirección",
    "city": "Localidad",
    "postalCode": "Código postal",
    "sendRequest": "Enviar pedido",
    "askForHelp": "Hablar con nosotros",
    "autoridadeTributaria": "Software Certificado por la Autoridad Tributaria Nº2578.",
    "header": "Simplifique su facturación y ahorre tiempo en la gestión del negocio",
    "description": "Emita facturas de forma automática y organizada, sin complicaciones. Siempre tenga el control de sus ventas y pagos en un solo lugar.",
    "configurations": "Configuraciones",
    "invoicingData": "Datos de facturación",
    "communicationWithAT": "Configurar comunicación con la AT",
    "legalRequirement": "Para usar el sistema de facturación, es legalmente obligatorio activar la comunicación con la AT.",
    "atPortal": "Portal das Finanças",
    "createAtUser": "Cree un nuevo usuario en el Portal das Finanças.",
    "addAtUser": "Agregar usuario",
    "activateCommunication": "Activar comunicación",
    "addUserToBUK": "Agregue el nuevo usuario a BUK.",
    "atCredentials": "Credenciales",
    "atCredentialsUser": "Usuario de la AT",
    "atSectionTitle": "Autoridad Tributaria",
    "atSectionDescription": "Configure su acceso y comunicación",
    "authenticate": "Autenticación",
    "saftTitle": "Archivos SAF-T",
    "downloadSaft": "Descargar SAF-T",
    "viewAtCommunications": "Ver comunicaciones con la AT",
    "atCommunications": "Comunicaciones con la Autoridad Tributaria",
    "communicationType": "Tipo",
    "communicationInfo": "Detalle",
    "communicationResult": "Resultado",
    "communicationSuccess": "Éxito",
    "communicationError": "Error",
    "noAtCommunications": "No hay comunicaciones",
    "atCommunicationTypeSaft": "SAF-T",
    "atCommunicationTypeGt": "Guía de transporte",
    "previousPage": "Anterior",
    "nextPage": "Siguiente",
    "autoSendSaft": "Comunicar automáticamente con la AT (el día 2 de cada mes)",
    "autoCommunication": "Comunicación automática",
    "autoCommunicationDay": "Día 2 de cada mes",
    "communicationsList": "Lista de comunicaciones",
    "communicationsListDescription": "Consulte las comunicaciones con la AT",
    "consultCommunications": "Consultar",
    "deactivate": "Desactivar",
    "activate": "Activar",
    "logoRecommendedSize": "jpg, png (Tam. rec.: 384x128px)",
    "year": "Año",
    "month": "Mes",
    "authoritySiteDescription1": "Acceda al Portal das Finanças para crear un usuario",
    "authoritySiteDescription2": "El nombre de usuario puede usar <b>“BUK”</b>",
    "authoritySiteDescription3": "Elija una contraseña segura y agregue los siguientes permisos: <b>WFA</b> (Comunicación de facturación), <b>WSE</b> (Comunicación de series).",
    "authoritySiteDescription4": "Haga clic en <b>Enviar</b>",
    "openAuthoritySite": "Acceder al Portal das Finanças",
    "closeAndContinue": "Cerrar y continuar",
    "askForAccess": "Pedir acceso",
    "emailAddress": "Correo electrónico"
  },
  "ACTIVATE_INVOICING_AUTHORITY": {
    "img": "Autoridad Tributaria",
    "title": "Activar comunicación",
    "titleReconfigure": "Actualizar credenciales AT",
    "description": "Rellene el nombre de usuario y la contraseña creados previamente en el Portal das Finanças.",
    "descriptionReconfigure": "Introduzca el usuario y la contraseña del Portal das Finanças.",
    "userDescription": "En Portal das Finanças, el usuario tiene el formato {{vatNumber}}/número (ej: {{vatNumber}}/1). Introduzca abajo solo el número asignado al nuevo usuario.",
    "userLabel": "Usuario",
    "userPlaceholder": "Ej: 1",
    "userInvalid": "Introduzca el número de usuario asignado en Portal das Finanças.",
    "passwordLabel": "Contraseña",
    "passwordPlaceholder": "Introduzca la contraseña",
    "newAccountWarning": "Si acaba de crear este usuario en Portal das Finanças, pueden pasar varios minutos antes de estar disponible para la activación. Si la solicitud falla o se agota el tiempo de espera, vuelva a intentarlo después de unos 5 minutos.",
    "send": "Activar Comunicación"
  },
  "UPLOAD_INVOICING_LOGO": {
    "title": "Logotipo",
    "fileType": "jpg, png (min. 640x640px)",
    "upload": "Subir",
    "reset": "Eliminar"
  },
  "EMAIL_INVOICE_MODAL": {
    "successTitle": "Enviado",
    "successMessage": "Documentos enviados con éxito.",
    "title": "Confirmar email",
    "emailLabel": "Email",
    "emailPlaceholder": "Email para donde enviar la factura",
    "send": "Enviar ahora"
  },
  "CLIENT_SALES": {
    "emptyState": {
      "title": "Sin ventas",
      "description": "No existen ventas para mostrar."
    }
  },
  "REPORTS_LIST": {
    "title": "Informes",
    "generalReport": "Informe General",
    "generalReportDesc": "Resumen de las principales métricas de su negocio",
    "explore": "Explorar",
    "sectionSales": "Ventas",
    "sectionCommissions": "Comisiones",
    "sectionPayments": "Pagos",
    "sectionBookings": "Reservas",
    "sectionClients": "Clientes",
    "sectionCommunication": "Comunicación"
  },
  "CALENDAR_TOOLTIP_TEMPLATE": {
    "reason": "Motivo",
    "provider": "Proveedor",
    "schedule": "Horario",
    "patient": "Cliente",
    "service": "Servicio",
    "roomEquipment": "Sala/Equipo",
    "roomOccupied": "Ocupado",
    "notes": "Notas",
    "noShow": "No Asistió",
    "confirmed": "Confirmado",
    "arrived": "Llegó",
    "cancelled": "Cancelado",
    "prepaymentInvoice": "Factura de prepago",
    "invoice": "Factura",
    "sale": "Venta"
  },
  "REPORTS_SERVICE": {
    "salesSummaryTitle": "Items Vendidos",
    "salesSummaryDescription": "Descripción del Resumen de Ventas",
    "salesTotalsTitle": "Totales de Ventas",
    "salesTotalsDescription": "Descripción de los Totales de Ventas",
    "salesMonthlyTitle": "Ventas mensuales",
    "salesMonthlyDescription": "Ventas agrupadas por mes con totales de facturación y pagos.",
    "taxesSummaryTitle": "Resumen de impuestos",
    "taxesSummaryDescription": "Resumen de todas las transacciones relacionadas con impuestos.",
    "vatRatesFilterLabel": "Tipo de IVA",
    "vatRatesFilterPlaceholder": "Seleccione los tipos de IVA",
    "saleStatusFilterLabel": "Estado de la Venta",
    "saleStatusFilterPlaceholder": "Seleccione el estado de la venta",
    "invoiceStatusFilterLabel": "Estado de la Factura",
    "invoiceStatusFilterPlaceholder": "Seleccione el estado de la factura",
    "createdByUserFilterLabel": "Creado por usuario",
    "createdByUserFilterPlaceholder": "Seleccione el usuario que creó",
    "providerFilterLabel": "Profesional",
    "providerFilterPlaceholder": "Seleccione el profesional",
    "providersFilterLabel": "Profesionales",
    "providersFilterPlaceholder": "Seleccione los profesionales",
    "saleItemTypeFilterLabel": "Tipo de Ítem de la Venta",
    "saleItemTypeFilterPlaceholder": "Seleccione el tipo de ítem de la venta",
    "salesListTitle": "Lista de ventas",
    "salesListDescription": "Listado completo de todas las transacciones de venta individuales.",
    "paymentsListTitle": "Lista de pagos",
    "paymentsListDescription": "Listado completo de todos los pagos individuales.",
    "paymentsSummaryTitle": "Pagos por método",
    "paymentsSummaryDescription": "Totales de pagos agrupados por método de pago.",
    "onlinePaymentsListTitle": "Lista de pagos online",
    "onlinePaymentsListDescription": "Prepago online realizado en el momento de la cita.",
    "upfrontPaymentsSummaryTitle": "Pagos anticipados por mes",
    "upfrontPaymentsSummaryDescription": "Análisis de prepagos y depósitos a lo largo del tiempo.",
    "tipsMonthlyTitle": "Propinas Teya por mes",
    "tipsMonthlyDescription": "Total de propinas recibidas vía terminal Teya, agrupadas por mes.",
    "commissionsListTitle": "Lista de comisiones",
    "commissionsListDescription": "Listado completo de todas las transacciones de comisión individuales.",
    "commissionsSummaryTitle": "Resumen de comisiones",
    "commissionsSummaryDescription": "Visión general de las comisiones obtenidas por miembros del equipo, ubicaciones e ítems de venta.",
    "paymentMethodFilterLabel": "Método de pago",
    "paymentMethodFilterPlaceholder": "Seleccione el método de pago",
    "bookingsListTitle": "Lista de citas",
    "bookingsListDescription": "Listado completo de todas las citas programadas.",
    "bookingsSummaryTitle": "Resumen de citas",
    "bookingsSummaryDescription": "Visión general de tendencias, cancelaciones y ausencias.",
    "cancellationsNoshowSummaryTitle": "Cancelaciones y ausencias por mes",
    "cancellationsNoshowSummaryDescription": "Análisis de cancelaciones y ausencias para identificar patrones.",
    "workingHoursSummaryTitle": "Resumen de horas de trabajo",
    "workingHoursSummaryDescription": "Visión general de las horas operativas y la productividad.",
    "incidentTypeFilterLabel": "Tipo",
    "incidentTypeFilterPlaceholder": "Seleccione el tipo",
    "incidentTypeBoth": "Cancelaciones y ausencias",
    "incidentTypeCancellations": "Cancelaciones",
    "incidentTypeNoshows": "Ausencias",
    "cancelledByFilterLabel": "Cancelado por",
    "cancelledByFilterPlaceholder": "Seleccione quién canceló",
    "cancelledByAll": "Todos",
    "cancelledByClient": "Cliente",
    "cancelledByBusiness": "Negocio",
    "periodTypeFilterLabel": "Periodo",
    "periodTypeFilterPlaceholder": "Seleccione la agrupación",
    "periodTypeDay": "Día",
    "periodTypeWeek": "Semana",
    "periodTypeMonth": "Mes",
    "bookingsByProviderTitle": "Citas por profesional",
    "bookingsByProviderDescription": "Número de citas agrupadas por profesional.",
    "bookingsByProviderServiceTitle": "Citas por profesional y servicio",
    "bookingsByProviderServiceDescription": "Número de citas agrupadas por profesional y servicio.",
    "clientsListTitle": "Listado de clientes",
    "clientsListDescription": "Lista de clientes con estadísticas de citas y cancelaciones.",
    "clientsSummaryTitle": "Resumen de clientes",
    "clientsSummaryDescription": "Visión general de la base de clientes, adquisición y retención.",
    "clientTypeFilterLabel": "Tipo de cliente",
    "clientTypeFilterPlaceholder": "Seleccione el tipo de cliente",
    "clientTypeAll": "Todos",
    "clientTypeNew": "Nuevos",
    "clientTypeReturning": "Recurrentes",
    "clientsBirthdaysTitle": "Cumpleaños",
    "clientsBirthdaysDescription": "Clientes con cumpleaños en el período seleccionado.",
    "smsListTitle": "SMS enviados",
    "smsListDescription": "Listado de SMS enviados con estado de entrega.",
    "bookingStatusFilterLabel": "Estado",
    "bookingStatusFilterPlaceholder": "Seleccione los estados de las citas",
    "bookingStatusScheduled": "Programada",
    "bookingStatusCompleted": "Completada",
    "servicesFilterLabel": "Servicios",
    "servicesFilterPlaceholder": "Seleccione los servicios",
    "categoriesFilterLabel": "Categorías",
    "categoriesFilterPlaceholder": "Seleccione las categorías"
  },
  "SALE_ITEM_TYPE": {
    "all": "Todos",
    "service": "Servicio",
    "product": "Producto",
    "other": "Otro"
  },
  "INVOICE_STATUS": {
    "invoiced": "Facturado",
    "uninvoiced": "Por facturar",
    "partiallyInvoiced": "Parcialmente facturado"
  },
  "REPORT_PAGE": {
    "emptyState": {
      "title": "Sin datos",
      "description": "No existen datos para mostrar."
    },
    "filterFieldPlaceholder": "Buscar...",
    "downloadCsvError": "No se pudo generar el archivo CSV. Por favor, inténtelo de nuevo más tarde.",
    "downloadCsv": "Descargar"
  },
  "REPORTS_TABLE": {
    "saleItem": "Artículo",
    "category": "Categoría",
    "itemType": "Tipo de Artículo",
    "quantity": "Cantidad",
    "grossSales": "Venta Bruta",
    "discounts": "Descuentos",
    "netSales": "Venta Neta",
    "tax": "Impuesto",
    "total": "Total",
    "totalColumnTitle": "Métrica",
    "totalColumnValue": "Valor",
    "saleReference": "Venta",
    "clientName": "Nombre",
    "clientNamePhone": "Nombre / teléfono",
    "createdByUserName": "Registrado por",
    "createdAt": "Fecha",
    "saleDate": "Fecha",
    "monthStart": "Mes",
    "salesCount": "N.º ventas",
    "paidAmountCents": "Importe pagado",
    "pendingCents": "Importe pendiente",
    "subtotalCents": "Subtotal (sin IVA)",
    "vatCents": "IVA",
    "taxName": "Impuesto",
    "taxRate": "Tipo",
    "taxableAmountCents": "Base imponible",
    "taxCollectedCents": "Impuesto repercutido",
    "totalWithTaxCents": "Total con impuesto",
    "transactionCount": "N.º ventas",
    "periodLabel": "Mes",
    "paymentsCollectedCount": "Pagos recibidos",
    "amountCollectedCents": "Importe recibido",
    "totalCancelled": "Total canc.",
    "cancellationRatePercent": "Tasa de canc.",
    "cancelledByClient": "Canc. p/ cliente",
    "cancelledByBusiness": "Canc. p/ negocio",
    "totalNoShows": "Total ausencias",
    "noshowRatePercent": "Tasa de ausencias",
    "lostRevenueCents": "Ingresos perdidos",
    "mostCancelledService": "Servicio más cancelado",
    "mostNoShowClient": "Cliente con más ausencias",
    "totalCents": "Valor total",
    "saleStatusLabel": "Estado",
    "paymentMethod": "Método de pago",
    "paymentCount": "N.º pagos",
    "tipCount": "N.º propinas",
    "tipCents": "Propinas",
    "amountCents": "Valor",
    "paidAt": "Fecha de pago",
    "totalAmountPaidCents": "Importe total pagado",
    "priceToMerchant": "Importe establecimiento",
    "priceToBuk": "Comisión BUK",
    "clientEmail": "Email",
    "clientPhone": "Teléfono",
    "providerName": "Profesional",
    "totalSalesCents": "Total ventas",
    "totalCommissionsCents": "Total comisiones",
    "commissionRateAvgPercent": "Tasa comisión",
    "servicesCommissionCents": "Comisión servicios",
    "productsCommissionCents": "Comisión productos",
    "availableHours": "Horas disponibles",
    "bookedHours": "Horas reservadas",
    "unbookedHours": "Horas libres",
    "utilizationRatePercent": "Tasa de utilización",
    "revenuePerHourCents": "Ingresos por hora",
    "serviceName": "Servicio / Producto",
    "serviceTotalCents": "Total (con IVA)",
    "commissionAmountCents": "Comisión (con IVA)",
    "dateInit": "Fecha y hora",
    "durationMinutes": "Duración (min)",
    "bookingStatusLabel": "Estado",
    "bookingSourceLabel": "Origen de la cita",
    "priceCents": "Precio",
    "notes": "Notas",
    "firstName": "Nombre",
    "lastName": "Apellido",
    "dob": "Cumpleaños",
    "email": "Email",
    "phoneNumber": "Teléfono",
    "campaignsEmailSms": "Campañas e-mail y SMS",
    "bookingsCount": "Citas",
    "cancellationsCount": "Cancelaciones",
    "totalBookingsValueCents": "Valor total citas",
    "templateLabel": "Tipo de SMS",
    "bookingDateInit": "Fecha de la cita",
    "messageParts": "Partes SMS",
    "smsProviderLabel": "Operador",
    "deliveryStatusLabel": "Estado de entrega"
  },
  "GOOGLE_MEET_PAGE": {
    "intro": "Ofrece consultas y sesiones por videollamada: el enlace de Google Meet se incluye automáticamente en los emails y recordatorios enviados al cliente y aparece en la reserva.",
    "howToTitle": "Cómo usarlo",
    "step1": "Abre Servicios y edita el servicio que quieras ofrecer por videollamada.",
    "step2": "Activa la opción «Generar enlace de videollamada» y guarda.",
    "step3": "Cada nueva reserva de ese servicio recibe su propio enlace de Google Meet, enviado al cliente y visible en la agenda («Abrir videollamada»).",
    "goToServices": "Ir a Servicios",
    "fixedLinkTitle": "Enlace fijo (opcional)",
    "fixedLinkDesc": "¿Prefieres usar siempre la misma sala? Define un enlace fijo que se enviará en las reservas que no tengan un enlace propio. Puede ser un enlace de Google Meet o de cualquier otra plataforma (Zoom, Microsoft Teams, etc.). Déjalo vacío para quitarlo.",
    "fixedLinkLabel": "Enlace de la videollamada",
    "fixedLinkInvalid": "Introduce un enlace válido (que empiece por https://)."
  }
}
